/**
 * Static Amazon gift catalog — 2-3 verified products per preset interest label in
 * `interestGroups.js`. Generated by `scripts/build-amazon-gift-catalog.mjs`;
 * every ASIN below resolved to a live product page when it was captured.
 *
 * Do not hand-edit: rerun the builder (or `npm run verify:amazon-links` to check
 * for link rot). `priceText`/`priceValue`/`rating`/`reviewCount` are snapshots
 * taken on or before 2026-08-14 and will drift until the Amazon Product
 * Advertising API replaces this file. Product URLs are built by
 * `utils/amazonLinks.js` so the affiliate tag can be added in one place.
 */

/** Last build date of the price, rating and review snapshots below (ISO date). */
export const CATALOG_CAPTURED_AT = "2026-08-14";

/** Preset interest label -> verified Amazon products for that interest. */
export const AMAZON_GIFT_CATALOG = {
  Coffee: [
    {
      asin: "B00VTA9F6U",
      title: "Wacaco Minipresso GR",
      fullTitle: "Wacaco Minipresso GR, Portable Espresso Machine, Compatible Ground Coffee, Hand Coffee Maker, Travel Gadgets, Manually Operated, Perfect for Camping, Hiking",
      brand: "WACACO",
      priceText: "$37.52",
      priceValue: 37.52,
      rating: 4.4,
      reviewCount: 6164,
      imageUrl: "https://m.media-amazon.com/images/I/71hjzLO5bkL._AC_SL640_.jpg",
      interests: ["Coffee"],
    },
    {
      asin: "B07W5WRPNZ",
      title: "Pour Over Coffee Maker Set",
      fullTitle: "Pour Over Coffee Maker Set | Kit Includes 40 OZ Gooseneck Kettle with Thermometer, Coffee Mill Grinder & 20 OZ Coffee Dripper Brewer | Great Replacement for Coffee Machines",
      brand: "MITBAK",
      priceText: "$72.80",
      priceValue: 72.8,
      rating: 4.6,
      reviewCount: 1001,
      imageUrl: "https://m.media-amazon.com/images/I/81sRItsLjPL._AC_SL640_.jpg",
      interests: ["Coffee"],
    },
    {
      asin: "B0BF7DXLBF",
      title: "Fellow Stagg EKG Pro Gooseneck Electric Kettle",
      fullTitle: "Fellow Stagg EKG Pro Gooseneck Electric Kettle, Brew Timer, 0.9 Liter | To-the-Degree Temp Control, Color LCD, Temp Hold, Stainless Steel, for Pour-Over Coffee & Tea, Matte Black",
      brand: "Fellow",
      priceText: "$179.95",
      priceValue: 179.95,
      rating: 4.3,
      reviewCount: 281,
      imageUrl: "https://m.media-amazon.com/images/I/61grHEIj7PL._AC_SL640_.jpg",
      interests: ["Coffee"],
    },
  ],
  Tea: [
    {
      asin: "B00595KC1S",
      title: "Tiesta Tea - Chai Love",
      fullTitle: "Tiesta Tea - Chai Love, Loose Leaf, Spiced Chai Black Tea, Premium Blend | High Caffeinated, Make Hot or Iced & Brews Up to 50 Cups, 4 Ounce Refillable Tin",
      brand: "Tiesta Tea",
      priceText: "$14.95",
      priceValue: 14.95,
      rating: 4.6,
      reviewCount: 1303,
      imageUrl: "https://m.media-amazon.com/images/I/8145FhuGQIL._SL1500_.jpg",
      interests: ["Tea"],
    },
    {
      asin: "B08VY5TS6P",
      title: "Teabloom Exceptional Organic & Kosher Certified Loose…",
      fullTitle: "Teabloom Exceptional Organic & Kosher Certified Loose Leaf Tea Chest, World's Largest Tea Collection with 24 Varieties of Black, Green, White, Oolong, and Herbal Teas",
      brand: "Teabloom",
      priceText: "$59.95",
      priceValue: 59.95,
      rating: 4.7,
      reviewCount: 170,
      imageUrl: "https://m.media-amazon.com/images/I/91DiFQXqAWL._SL1500_.jpg",
      interests: ["Tea"],
    },
    {
      asin: "B0F3PLV59Y",
      title: "Tea Gift Set for Women",
      fullTitle: "Tea Gift Set for Women - 6 Herbal Loose Leaf Tea Blends, Insulated Ceramic Cup with Infuser & Lid | Birthday, Mother's Day, Anniversary & Retirement Gift for Her",
      brand: "Harmoleaf",
      priceText: "$34.99",
      priceValue: 34.99,
      rating: 4.7,
      reviewCount: 168,
      imageUrl: "https://m.media-amazon.com/images/I/91xM1hj2mKL._AC_SL640_.jpg",
      interests: ["Tea"],
    },
  ],
  Wine: [
    {
      asin: "B00M72R5GG",
      title: "Rabbit Wine Aerator Pourer Spout",
      fullTitle: "Rabbit Wine Aerator Pourer Spout - Instant In-Bottle Aerating for Richer, Smoother Wine - Dripless Pour Spout for Red and White Wine",
      brand: "Rabbit",
      priceText: "$14.95",
      priceValue: 14.95,
      rating: 4.6,
      reviewCount: 4022,
      imageUrl: "https://m.media-amazon.com/images/I/51HSJv404TL._AC_SL640_.jpg",
      interests: ["Wine"],
    },
    {
      asin: "B07X8TQ8PD",
      title: "Wine Decanter Built-in Aerator Pourer",
      fullTitle: "Wine Decanter Built-in Aerator Pourer, Wine Carafe, Red Wine Decanter,100% Lead-free Crystal Glass, Wine Hand-held Aerator, Wine Gift, Wine Accessories (Clear，Crystal) | Hand-Blown 100% Lead-free Crystal Glass, Wine Gift for Wine Lovers, Wine Accessories, Wine Hand-held Aerator",
      brand: "Jiaran",
      priceText: "$41.50",
      priceValue: 41.5,
      rating: 4.6,
      reviewCount: 1980,
      imageUrl: "https://m.media-amazon.com/images/I/81G3dhMyx7L._AC_SL640_.jpg",
      interests: ["Wine"],
    },
    {
      asin: "B07R5FNNJ6",
      title: "YouYah Wine Decanter Set",
      fullTitle: "YouYah Wine Decanter Set,Red Wine Carafe with Built-in-Aerator,Wine Aerator,Wine Gifts for Christmas,Stainless Steel Pourer Lid,Filter,100% Hand Blown Lead-free Crystal Glass",
      brand: "NEW PACIFIC YOUYAH",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.8,
      reviewCount: 1469,
      imageUrl: "https://m.media-amazon.com/images/I/71rjfkCvCYL._AC_SL640_.jpg",
      interests: ["Wine"],
    },
  ],
  Cocktails: [
    {
      asin: "B08BYJ8KSR",
      title: "KITESSENSU Cocktail Shaker Set Bartender Kit with Stand",
      fullTitle: "KITESSENSU Cocktail Shaker Set Bartender Kit with Stand | Bar Set Drink Mixer Set with All Essential Accessory Tools: Martini Shaker, Jigger, Strainer, Mixer Spoon, Muddler, Liquor Pourers |Silver",
      brand: "KITESSENSU",
      priceText: "$32.38",
      priceValue: 32.38,
      rating: 4.7,
      reviewCount: 4291,
      imageUrl: "https://m.media-amazon.com/images/I/71glMBKGZqL._AC_SL640_.jpg",
      interests: ["Cocktails"],
    },
    {
      asin: "B0CH83JXCR",
      title: "BARE BARREL® Mixology Bartender Kit Bar Set",
      fullTitle: "BARE BARREL® Mixology Bartender Kit Bar Set | 14-Piece Cocktail Shaker Set | Martini Barware Mixing Tools for Home Bartending | Incl. 35 Recipe Cards | Gift Set (28oz Boston Shaker, Copper/Black)",
      brand: "Bare Barrel",
      priceText: "$99.99",
      priceValue: 99.99,
      rating: 4.7,
      reviewCount: 757,
      imageUrl: "https://m.media-amazon.com/images/I/81LS9-ghGJL._AC_SL640_.jpg",
      interests: ["Cocktails"],
    },
    {
      asin: "B0FH76Y7N4",
      title: "Cocktail Shaker Set",
      fullTitle: "Cocktail Shaker Set, 18-Piece Bartender Kit with Stand, Bar Tool Set | 18/8 Stainless Steel Mixology Kit with Acrylic Stand for Home Bar, Bar Cart, Parties, Martinis, Margaritas and Mixed Drinks",
      brand: "ARTFLY",
      priceText: "$16.99",
      priceValue: 16.99,
      rating: 4.7,
      reviewCount: 356,
      imageUrl: "https://m.media-amazon.com/images/I/81yD9K5jJNL._AC_SL640_.jpg",
      interests: ["Cocktails"],
    },
  ],
  Snacks: [
    {
      asin: "B004D9XYWU",
      title: "A Gift Inside Chocolate Gift Basket",
      fullTitle: "A Gift Inside Chocolate Gift Basket - Sweet Treats Gift Tray, Chocolates Gift Basket for Mom, Dad, Family & Friends",
      brand: "A Gift Inside",
      priceText: "$42.95",
      priceValue: 42.95,
      rating: 4.6,
      reviewCount: 13165,
      imageUrl: "https://m.media-amazon.com/images/I/91+JkOrnbML._SL1500_.jpg",
      interests: ["Snacks"],
    },
    {
      asin: "B082JMX25J",
      title: "Sahale Snacks Glazed Mix Nut Blend Variety Pack",
      fullTitle: "Sahale Snacks Glazed Mix Nut Blend Variety Pack, 4 Oz Grab & Go Bags | Pack of 6, Kosher & Certified Gluten-Free Snacks, Four Different Dry-Roasted Deluxe Mixed Nuts Blends Included",
      brand: "Sahale Snacks",
      priceText: "$28.34",
      priceValue: 28.34,
      rating: 4.6,
      reviewCount: 9243,
      imageUrl: "https://m.media-amazon.com/images/I/81aCLcZjROL._SL1500_.jpg",
      interests: ["Snacks"],
    },
    {
      asin: "B0D3DWFT6X",
      title: "Snack Box Gift Basket for Men",
      fullTitle: "Snack Box Gift Basket for Men, Birthday Gift for Men, Women, Food Care Package, Unique Tins of Assorted Nuts, Snacks in Stunning Case - Treat for Men, Women, Dad, Friends, Family, Fathers Day Gift",
      brand: "SUGAR PLUM",
      priceText: "$59.99",
      priceValue: 59.99,
      rating: 4.5,
      reviewCount: 288,
      imageUrl: "https://m.media-amazon.com/images/I/91LAAsRpaXL._SL1500_.jpg",
      interests: ["Snacks"],
    },
  ],
  Baking: [
    {
      asin: "B0BWHJ1FNK",
      title: "Mixing Bowls with Airtight Lids Set",
      fullTitle: "Mixing Bowls with Airtight Lids Set, 26PCS Stainless Steel Khaki Bowls with Grater Attachments, Non-Slip Bottoms & Kitchen Gadgets Set, Size 7, 4, 2.5, 2.0,1.5, 1QT, Great for Mixing & Serving",
      brand: "Umite Chef",
      priceText: "$35.99",
      priceValue: 35.99,
      rating: 4.8,
      reviewCount: 5019,
      imageUrl: "https://m.media-amazon.com/images/I/71qSOq9842L._AC_SL640_.jpg",
      interests: ["Baking"],
    },
    {
      asin: "B0FPWRCTSK",
      title: "HOTEC Oven Liners for Bottom of Oven",
      fullTitle: "HOTEC Oven Liners for Bottom of Oven, 3-Pack 17&#34;x25&#34; Large Oven Mats Heavy Duty Non-Stick, BPA & PFOA Free, Protector for Electric, Gas, Toaster Ovens & Grills Heat Resistant 500°F",
      brand: "HOTEC",
      priceText: "$9.48",
      priceValue: 9.48,
      rating: 4.5,
      reviewCount: 131,
      imageUrl: "https://m.media-amazon.com/images/I/71y3wLnavxL._AC_SL640_.jpg",
      interests: ["Baking"],
    },
    {
      asin: "B0BDCBDFTP",
      title: "Baketivity x Duff Goldman Unicorn Cookies Kids Baking Kit",
      fullTitle: "Baketivity x Duff Goldman Unicorn Cookies Kids Baking Kit | Cooking Kits with Premeasured Ingredients, Decorating Supplies, STEM Activities for Girls and Boys Ages 6-12",
      brand: "Baketivity",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.5,
      reviewCount: 121,
      imageUrl: "https://m.media-amazon.com/images/I/81l+NTxkrAL._SL1500_.jpg",
      interests: ["Baking"],
    },
  ],
  BBQ: [
    {
      asin: "B08CX8D3BH",
      title: "ROMANTICIST 26pcs Grilling Gifts for Men",
      fullTitle: "ROMANTICIST 26pcs Grilling Gifts for Men, Dad Gifts for Father's Day, Stainless Steel BBQ Grill Accessories Tools Set, Heavy Duty BBQ Utensils Kit with Apron, Thermometer, Mats in Aluminum Case Brown",
      brand: "ROMANTICIST",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.7,
      reviewCount: 5637,
      imageUrl: "https://m.media-amazon.com/images/I/71H3s7e1YAL._AC_SL640_.jpg",
      interests: ["BBQ"],
    },
    {
      asin: "B079J4KT8H",
      title: "Kaluns Grilling Accessories",
      fullTitle: "Kaluns Grilling Accessories, Gifts for Men Christmas Grilling Gifts for Dad, Heavy Duty Stainless Steel BBQ Grill Tools Set for Outdoor Grill with Aluminum Case and Apron, Birthday Gifts for Men Dad",
      brand: "Kaluns",
      priceText: "$27.97",
      priceValue: 27.97,
      rating: 4.7,
      reviewCount: 4855,
      imageUrl: "https://m.media-amazon.com/images/I/81i+4JZR+dL._AC_SL640_.jpg",
      interests: ["BBQ"],
    },
    {
      asin: "B09SHHF62Y",
      title: "POLIGO 22PCS Heavy Duty BBQ Grill Accessories Set",
      fullTitle: "POLIGO 22PCS Heavy Duty BBQ Grill Accessories Set, Non-Slip Grill Tools for Outdoor Grill Set Stainless Steel Grill Utensils Set, Deluxe Grilling Tools Set in Aluminum Case Ideal Gifts for Men Brown",
      brand: "POLIGO",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.7,
      reviewCount: 4679,
      imageUrl: "https://m.media-amazon.com/images/I/71VaIfgu9FL._AC_SL640_.jpg",
      interests: ["BBQ"],
    },
  ],
  Chocolate: [
    {
      asin: "B08XWVFTKS",
      title: "Lindt Gourmet Truffles Assorted Chocolate Candy Gift Box",
      fullTitle: "Lindt Gourmet Truffles Assorted Chocolate Candy Gift Box, 14.7 oz.",
      brand: "Lindt",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.3,
      reviewCount: 4346,
      imageUrl: "https://m.media-amazon.com/images/I/71LrbyAIo-L._SL1500_.jpg",
      interests: ["Chocolate"],
    },
    {
      asin: "B00NIPV8QO",
      title: "A Gift Inside Fresh Fruit Basket Gift Box with Mixed…",
      fullTitle: "A Gift Inside Fresh Fruit Basket Gift Box with Mixed Fresh Fruit, Pears, Apples, Nuts & Sweet Snacks – Gourmet Fruit Gift Basket for Every Occasion",
      brand: "A Gift Inside",
      priceText: "$46.95",
      priceValue: 46.95,
      rating: 4.3,
      reviewCount: 1002,
      imageUrl: "https://m.media-amazon.com/images/I/81E080BGwML._SL1500_.jpg",
      interests: ["Chocolate"],
    },
    {
      asin: "B0FDM48PD9",
      title: "Godiva Gold Assorted Belgian Chocolate Gift Box",
      fullTitle: "Godiva Gold Assorted Belgian Chocolate Gift Box, Gourmet, 15 Pc | Belgian dark, milk & white chocolate, Pralines, ganaches & caramels, Kosher, Iconic gold box, Great for gifting",
      brand: "Godiva Chocolatier",
      priceText: "$40.00",
      priceValue: 40,
      rating: 4.5,
      reviewCount: 194,
      imageUrl: "https://m.media-amazon.com/images/I/715-QUIBDWL._SL1500_.jpg",
      interests: ["Chocolate"],
    },
  ],
  Running: [
    {
      asin: "B09B22DZ9W",
      title: "INOXTO Running Hydration Vest Backpack",
      fullTitle: "INOXTO Running Hydration Vest Backpack,Lightweight Insulated Pack with 1.5L Water Bladder Bag Daypack for Hiking Trail Running Cycling Race Marathon for Women Men",
      brand: "IX INOXTO",
      priceText: "$23.99",
      priceValue: 23.99,
      rating: 4.4,
      reviewCount: 2517,
      imageUrl: "https://m.media-amazon.com/images/I/71LMLMzvgOL._AC_SL640_.jpg",
      interests: ["Running"],
    },
    {
      asin: "B0CGPYLG6H",
      title: "Running Phone Holder Vest with 500ml/17oz Water Bottle",
      fullTitle: "Running Phone Holder Vest with 500ml/17oz Water Bottle | Reflective Hydration Vest | Adjustable | Light | 6 Pockets for Running Accessories | Unisex",
      brand: "SWIFTVEST",
      priceText: "$35.99",
      priceValue: 35.99,
      rating: 4.5,
      reviewCount: 1282,
      imageUrl: "https://m.media-amazon.com/images/I/71BF2u7JKoL._AC_SL640_.jpg",
      interests: ["Running"],
    },
    {
      asin: "B0DXKYXYDQ",
      title: "Running Vest with 2L Water Bladder",
      fullTitle: "Running Vest with 2L Water Bladder, Hydration Backpack, U.S. Design Patent, Lightweight Hydration Pack with Gear Holder, Reflective Chest Pack for Men Women",
      brand: "Zelvot",
      priceText: "$38.59",
      priceValue: 38.59,
      rating: 4.5,
      reviewCount: 854,
      imageUrl: "https://m.media-amazon.com/images/I/91ckXNRHAaL._AC_SL640_.jpg",
      interests: ["Running"],
    },
  ],
  Biking: [
    {
      asin: "B079K5N7KF",
      title: "Bicycle Repair Bag With Tire Pump",
      fullTitle: "Bicycle Repair Bag With Tire Pump, Portable Tool Kit for Camping Travel - Bike Glueless Patches, Maintenance Essentials All in One Safety Kit",
      brand: "XCH Robots",
      priceText: "$24.89",
      priceValue: 24.89,
      rating: 4.5,
      reviewCount: 9965,
      imageUrl: "https://m.media-amazon.com/images/I/71MJCa8DlFL._AC_SL640_.jpg",
      interests: ["Biking"],
    },
    {
      asin: "B0BHQ4KLF7",
      title: "DURATECH 41 Pieces Bicycle Repair Tools",
      fullTitle: "DURATECH 41 Pieces Bicycle Repair Tools, Bike Tools Kit with Storage Box | Mountain Bike Repair Tools, Chain Riveter, Tire Levers, Crank Puller",
      brand: "DURATECH",
      priceText: "$59.99",
      priceValue: 59.99,
      rating: 4.3,
      reviewCount: 1908,
      imageUrl: "https://m.media-amazon.com/images/I/81dFAgX20DL._AC_SL640_.jpg",
      interests: ["Biking"],
    },
    {
      asin: "B08Z3K1RHP",
      title: "23 Piece Bike Tool Kit",
      fullTitle: "23 Piece Bike Tool Kit - Bicycle Repair Tool Box Compatible | Mountain/Road Bike Maintenance Tool Set with Storage Case",
      brand: "cyclists",
      priceText: "$84.98",
      priceValue: 84.98,
      rating: 4.7,
      reviewCount: 1414,
      imageUrl: "https://m.media-amazon.com/images/I/71bzH7rtJ2L._AC_SL640_.jpg",
      interests: ["Biking"],
    },
  ],
  Yoga: [
    {
      asin: "B01MY5MZSQ",
      title: "Gaiam Yoga Mat Classic Print",
      fullTitle: "Gaiam Yoga Mat Classic Print, 4mm Non-Slip Mat | Lightweight 4mm print yoga mat with non-slip grip. Ideal for yoga, Pilates & floor workouts at home or studio.",
      brand: "Gaiam",
      priceText: "$21.04",
      priceValue: 21.04,
      rating: 4.5,
      reviewCount: 12564,
      imageUrl: "https://m.media-amazon.com/images/I/81T1NUS+UwL._AC_SL640_.jpg",
      interests: ["Yoga"],
    },
    {
      asin: "B07JQCVBBZ",
      title: "Gruper Yoga Mat Non Slip",
      fullTitle: "Gruper Yoga Mat Non Slip, Eco Friendly Fitness Exercise Mat with Carrying Strap,Pro Yoga Mats for Women,Workout Mats for Home, Pilates and Floor Exercises",
      brand: "Gruper",
      priceText: "$25.19",
      priceValue: 25.19,
      rating: 4.4,
      reviewCount: 10458,
      imageUrl: "https://m.media-amazon.com/images/I/71MQ8weHJOL._AC_SL640_.jpg",
      interests: ["Yoga"],
    },
    {
      asin: "B099GCWYLH",
      title: "WRISTBuddy® Yoga Blocks 2 Pack",
      fullTitle: "WRISTBuddy® Yoga Blocks 2 Pack, High Density Non-Slip, Hand-Shaped Design | 60% less wrist pressure —patented hand-shaped design eases wrist discomfort for yoga, Pilates, push-ups, planks & handstands.",
      brand: "WRIST BUDDY",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.5,
      reviewCount: 1394,
      imageUrl: "https://m.media-amazon.com/images/I/81zfzWZd+mL._AC_SL640_.jpg",
      interests: ["Yoga"],
    },
  ],
  Strength: [
    {
      asin: "B0DB1FDJ9C",
      title: "FITPLAM Adjustable dumbbell set",
      fullTitle: "FITPLAM Adjustable dumbbell set,20/35/45/55/70/90lbs Free Weights set with upgraded nut, 5 in 1 Weight Set Used as Kettlebells, Barbell, Push up Stand, Fitness Exercise for Home Gym Suitable Men/Women",
      brand: "FITPLAM",
      priceText: "$67.99",
      priceValue: 67.99,
      rating: 4.3,
      reviewCount: 1558,
      imageUrl: "https://m.media-amazon.com/images/I/71GkVlCHO9L._AC_SL640_.jpg",
      interests: ["Strength"],
    },
    {
      asin: "B0DK3H169C",
      title: "2026 FDB2 Updated Adjustable Dumbbell Set of 2",
      fullTitle: "2026 FDB2 Updated Adjustable Dumbbell Set of 2, 5-in-1/10-in-1 Weights Dumbbell Set with Storage Box, 25lbs/55lbs Adjustable Weights with Anti-slip Silicone Grip, Weight Set For Home Gym Suit both Men and Women",
      brand: "LifeOG",
      priceText: "$139.99",
      priceValue: 139.99,
      rating: 4.7,
      reviewCount: 513,
      imageUrl: "https://m.media-amazon.com/images/I/71AmIZX4gpL._AC_SL640_.jpg",
      interests: ["Strength"],
    },
    {
      asin: "B0CYZZ7PMX",
      title: "BYZOOM FITNESS Pure Series Adjustable Dumbbell",
      fullTitle: "BYZOOM FITNESS Pure Series Adjustable Dumbbell - 12.5/25/27.5/50/55/75lb - ONE UNIT OR PAIR(check QTY before purchase) - 5-in-1/ 10-in-1 / 15-in-1 / 21-in-1 Flexible Hand Weights for Home Apartment Garage Gym, Strength Training & Fitness Workouts, White OR Black",
      brand: "ByZoom Fitness",
      priceText: "$117.32",
      priceValue: 117.32,
      rating: 4.5,
      reviewCount: 248,
      imageUrl: "https://m.media-amazon.com/images/I/81NgSKfA9OL._AC_SL640_.jpg",
      interests: ["Strength"],
    },
  ],
  Recovery: [
    {
      asin: "B083L8RNJR",
      title: "TOLOCO Massage Gun",
      fullTitle: "TOLOCO Massage Gun, Deep Tissue Back Massage for Athletes for Pain Relief, Percussion Massager with 10 Massages Heads & Silent Brushless Motor, Relaxation Gifts for Men Women, Black",
      brand: "TOLOCO",
      priceText: "$39.98",
      priceValue: 39.98,
      rating: 4.4,
      reviewCount: 62368,
      imageUrl: "https://m.media-amazon.com/images/I/71Jot9nj6qL._AC_SL640_.jpg",
      interests: ["Recovery"],
    },
    {
      asin: "B0DB86TWRJ",
      title: "Massage Gun with Heat Massager Deep Tissue Muscle…",
      fullTitle: "Massage Gun with Heat Massager Deep Tissue Muscle Massager Gifts for Men | Back Massager for Athletes for Pain Relief Percussion Handheld Massage Gun Birthday Gifts for Him 7Heads&Silent Carrying case",
      brand: "AERLANG",
      priceText: "$30.39",
      priceValue: 30.39,
      rating: 4.4,
      reviewCount: 21445,
      imageUrl: "https://m.media-amazon.com/images/I/61Xgo1uzgpL._AC_SL640_.jpg",
      interests: ["Recovery"],
    },
    {
      asin: "B0FF9ZCW62",
      title: "RENPHO Active Thermacool 2 Massage Gun with Intuitive…",
      fullTitle: "RENPHO Active Thermacool 2 Massage Gun with Intuitive Heat and Cold Control | VA Display Handheld Percussion 10mm Deep Tissue Massager for Neck Back Muscle, FSA Eligible Gift for Men, Athletes, Women HSA",
      brand: "RENPHO",
      priceText: "$89.98",
      priceValue: 89.98,
      rating: 4.5,
      reviewCount: 8339,
      imageUrl: "https://m.media-amazon.com/images/I/61mtD8h+HyL._AC_SL640_.jpg",
      interests: ["Recovery"],
    },
  ],
  Headphones: [
    {
      asin: "B0C3HCD34R",
      title: "Soundcore by Anker Q20i Hybrid Active Noise Cancelling…",
      fullTitle: "Soundcore by Anker Q20i Hybrid Active Noise Cancelling Headphones, Black | Áudio Hi-Res Graves Potentes, Cancelamento de Ruído Headphone Bluetooth Over Ear, Personalização de Som via App, Ruído branco",
      brand: "Soundcore",
      priceText: "$44.99",
      priceValue: 44.99,
      rating: 4.5,
      reviewCount: 71827,
      imageUrl: "https://m.media-amazon.com/images/I/51CnDMbXZzL._AC_SL640_.jpg",
      interests: ["Headphones"],
    },
    {
      asin: "B0CCZ26B5V",
      title: "Bose QuietComfort Headphones",
      fullTitle: "Bose QuietComfort Headphones - Wireless Bluetooth Headphones, Active Over Ear Noise Cancelling and Mic, USB-C Charging, Deep Bass, Up to 24 Hours of Playtime, Black",
      brand: "Bose",
      priceText: "$229.00",
      priceValue: 229,
      rating: 4.5,
      reviewCount: 21404,
      imageUrl: "https://m.media-amazon.com/images/I/61windvlNZL._AC_SL640_.jpg",
      interests: ["Headphones"],
    },
    {
      asin: "B0BS1QCFHX",
      title: "Sony WH-CH720N Wireless Noise Cancelling Over-Ear…",
      fullTitle: "Sony WH-CH720N Wireless Noise Cancelling Over-Ear Headphones, Black | Comfortable Lightweight Design, Dual Noise Sensor technology, Up to 35 Hrs Battery with Quick Charging, Multipoint Connection",
      brand: "Sony",
      priceText: "$75.29",
      priceValue: 75.29,
      rating: 4.3,
      reviewCount: 16443,
      imageUrl: "https://m.media-amazon.com/images/I/51rpbVmi9XL._AC_SL640_.jpg",
      interests: ["Headphones"],
    },
  ],
  Audio: [
    {
      asin: "B0BRKPVZB4",
      title: "Bluetooth Speaker, 20W HD Sound, Portable Wireless, IPX5…",
      fullTitle: "Bluetooth Speaker, 20W HD Sound, Portable Wireless, IPX5 Waterproof, Up to 24H Playtime, TWS Pairing, for Home/Party/Outdoor/Camping/Beach Essentials, Electronic Gadgets, Birthday Gift (Black)",
      brand: "BolaButty",
      priceText: "$23.98",
      priceValue: 23.98,
      rating: 4.5,
      reviewCount: 38115,
      imageUrl: "https://m.media-amazon.com/images/I/8165VSHcJlL._AC_SL640_.jpg",
      interests: ["Audio"],
    },
    {
      asin: "B0CX1FRR27",
      title: "Portable Bluetooth Speaker Beach Essentials: IPX5…",
      fullTitle: "Portable Bluetooth Speaker Beach Essentials: IPX5 Waterproof for Outdoor | Powerful HD Sound,Dynamic Light,All Day Playtime,Wireless BT 5.3,TWS Pairing,Travel|Camping|Pool Accessorie,School Supplies",
      brand: "CHIFENCHY",
      priceText: "$19.99",
      priceValue: 19.99,
      rating: 4.6,
      reviewCount: 7675,
      imageUrl: "https://m.media-amazon.com/images/I/91chDri2ibL._AC_SL640_.jpg",
      interests: ["Audio"],
    },
    {
      asin: "B0DN2ZCZX6",
      title: "JBL Charge 6 Portable Bluetooth Speaker",
      fullTitle: "JBL Charge 6 Portable Bluetooth Speaker, Waterproof, Drop-Proof - Black | Long Battery Life Up To 28 Hours, Quick Charging, Built-In Powerbank, Weatherproof For Outdoor, Poolside, And Shower Use",
      brand: "JBL",
      priceText: "$149.95",
      priceValue: 149.95,
      rating: 4.6,
      reviewCount: 5821,
      imageUrl: "https://m.media-amazon.com/images/I/81pM9-KLvqL._AC_SL640_.jpg",
      interests: ["Audio"],
    },
  ],
  "Smart Home": [
    {
      asin: "B091FXLMS8",
      title: "Kasa Smart Plug Mini 15A",
      fullTitle: "Kasa Smart Plug Mini 15A, Smart Home Wi-Fi Outlet Works with Alexa, Google Home, No Hub Required, UL Certified, 2.4G WiFi Only, 4-Pack(EP10P4) , White",
      brand: "Kasa Smart",
      priceText: "$28.99",
      priceValue: 28.99,
      rating: 4.5,
      reviewCount: 40524,
      imageUrl: "https://m.media-amazon.com/images/I/51L3mlb5BXL._SL1093_.jpg",
      interests: ["Smart Home"],
    },
    {
      asin: "B0D7ZXYPRL",
      title: "GHome Smart Plug, WiFi Smart Plugs Work with Alexa and…",
      fullTitle: "GHome Smart Plug, WiFi Smart Plugs Work with Alexa and Google Home, Smart Outlet Timer with APP Remote Control, 2.4GHz Wi-Fi Only, No Hub Required, ETL FCC Listed, White",
      brand: "GHome Smart",
      priceText: "$9.99",
      priceValue: 9.99,
      rating: 4.4,
      reviewCount: 4338,
      imageUrl: "https://m.media-amazon.com/images/I/61bxEW13xHL._SL1500_.jpg",
      interests: ["Smart Home"],
    },
    {
      asin: "B0C36WXGP1",
      title: "Linkind Matter Smart Plug",
      fullTitle: "Linkind Matter Smart Plug, Work with Apple Home, Alexa, Siri, Google Home | Smart Outlet Timer & Schedule, Smart Home Automation, 15A/1800W, APP Remote Control, ETL Certified, 2.4G Wi-Fi Only, 4 Pack",
      brand: "Linkind",
      priceText: "$25.99",
      priceValue: 25.99,
      rating: 4.4,
      reviewCount: 1731,
      imageUrl: "https://m.media-amazon.com/images/I/61uRO-SLa+L._SL1500_.jpg",
      interests: ["Smart Home"],
    },
  ],
  Photography: [
    {
      asin: "B0C6DXY5KC",
      title: "Dylanto Kids Camera Instant Print",
      fullTitle: "Dylanto Kids Camera Instant Print,1080P Kids Instant Cameras that Print Photos,Christmas Birthday Gifts for Girls Age 3-12,Portable Toy for 3 4 5 6 7 8 9 10 Year Old Girls Boys Pink",
      brand: "Dylanto",
      priceText: "$33.99",
      priceValue: 33.99,
      rating: 4.5,
      reviewCount: 4651,
      imageUrl: "https://m.media-amazon.com/images/I/61ol+gwG2SL._AC_SL640_.jpg",
      interests: ["Photography"],
    },
    {
      asin: "B0CG7GHYXJ",
      title: "Polaroid Go Generation 2",
      fullTitle: "Polaroid Go Generation 2 - Mini Instant Camera + Film Bundle (16 Photos Included) - White (6282) | Polaroid Go Gen 2 Camera Plus Color Go Film, USB-C Cable, Wrist Strap, Guides, (16 Photos Included)",
      brand: "Polaroid",
      priceText: "$71.99",
      priceValue: 71.99,
      rating: 4.2,
      reviewCount: 2889,
      imageUrl: "https://m.media-amazon.com/images/I/71oASIjQhsL._AC_SL640_.jpg",
      interests: ["Photography"],
    },
    {
      asin: "B0BWNYPCT1",
      title: "Fujifilm Instax Mini 12 Instant Camera",
      fullTitle: "Fujifilm Instax Mini 12 Instant Camera - Lilac Purple | Automatic exposure with selfie mirror and parallax correction for photography, travel and parties",
      brand: "Fujifilm",
      priceText: "$83.98",
      priceValue: 83.98,
      rating: 4.6,
      reviewCount: 1526,
      imageUrl: "https://m.media-amazon.com/images/I/51BCl6AKK-L._AC_SL640_.jpg",
      interests: ["Photography"],
    },
  ],
  "Desk Setup": [
    {
      asin: "B08BRCT4JH",
      title: "BESIGN LS03 Aluminum Laptop Stand",
      fullTitle: "BESIGN LS03 Aluminum Laptop Stand, Ergonomic Detachable Computer Stand, Notebook Riser, Laptop Mount Compatible with Air, Pro, Dell, HP, Lenovo More 10-15.6&#34; Laptops, Silver",
      brand: "BESIGN",
      priceText: "$16.99",
      priceValue: 16.99,
      rating: 4.8,
      reviewCount: 24059,
      imageUrl: "https://m.media-amazon.com/images/I/71G8rdQin3L._AC_SL640_.jpg",
      interests: ["Desk Setup"],
    },
    {
      asin: "B08M94BTYC",
      title: "Lamicall Aluminum Laptop Stand for Desk for MacBook Air…",
      fullTitle: "Lamicall Aluminum Laptop Stand for Desk for MacBook Air Pro Neo 10-17.3'' | Adjustable Computer Stand, Ergonomic Laptop Riser, Foldable Portable Notebook Holder fits Dell HP Lenovo Office Home College",
      brand: "Lamicall",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.7,
      reviewCount: 10411,
      imageUrl: "https://m.media-amazon.com/images/I/71pNZrEkYWL._AC_SL640_.jpg",
      interests: ["Desk Setup"],
    },
    {
      asin: "B0B2P4B8WL",
      title: "Nulaxy 18&#34; Height Telescopic 360 Rotating Aluminum…",
      fullTitle: "Nulaxy 18&#34; Height Telescopic 360 Rotating Aluminum Laptop Stand Desk, Gray | Ergonomic Computer Holder Riser with Heat-Vent, Standing Desk Converter Holds 22 Lbs for Office Desk Use Fits 10-17&#34; Laptops",
      brand: "Nulaxy",
      priceText: "$58.99",
      priceValue: 58.99,
      rating: 4.7,
      reviewCount: 3216,
      imageUrl: "https://m.media-amazon.com/images/I/81t45M9tDbL._AC_SL640_.jpg",
      interests: ["Desk Setup"],
    },
  ],
  Gaming: [
    {
      asin: "B07CMS5Q6P",
      title: "Logitech G305 Lightspeed Wireless Gaming Mouse",
      fullTitle: "Logitech G305 Lightspeed Wireless Gaming Mouse - Black | HERO sensor, 12,000 DPI, Six programmable buttons, 250-hour battery, On-board memory",
      brand: "Logitech G",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.6,
      reviewCount: 36754,
      imageUrl: "https://m.media-amazon.com/images/I/51sg9BLSMTL._AC_SL640_.jpg",
      interests: ["Gaming"],
    },
    {
      asin: "B09ZY348SY",
      title: "Redragon M810 PRO Wireless RGB Gaming Mouse 10000 DPI…",
      fullTitle: "Redragon M810 PRO Wireless RGB Gaming Mouse 10000 DPI Remapping Keys | Cable-Free 0 Delay, Rapid-Fire Macro Keybinds, Vibing Backlight, Ergonomic Grip Body Comfort",
      brand: "Redragon",
      priceText: "$24.29",
      priceValue: 24.29,
      rating: 4.5,
      reviewCount: 3761,
      imageUrl: "https://m.media-amazon.com/images/I/51UCF1KOnKL._AC_SL640_.jpg",
      interests: ["Gaming"],
    },
    {
      asin: "B0B6Y52YXB",
      title: "Razer DeathAdder V3 Pro Wireless Gaming Mouse",
      fullTitle: "Razer DeathAdder V3 Pro Wireless Gaming Mouse, 64g, 90 Hr Battery, White | Focus Pro 30K Optical Sensor, Fast Optical Switches Gen-3, HyperSpeed Wireless, 5 Programmable Buttons",
      brand: "Razer",
      priceText: "$74.99",
      priceValue: 74.99,
      rating: 4.2,
      reviewCount: 2197,
      imageUrl: "https://m.media-amazon.com/images/I/61P+sPNpFFL._AC_SL640_.jpg",
      interests: ["Gaming"],
    },
  ],
  EDC: [
    {
      asin: "B01NAB328R",
      title: "BASTION Bolt Action Pen",
      fullTitle: "BASTION Bolt Action Pen, Stainless Steel Silver, HyperBolt & ZeroSeam EDC Pen, Refillable Metal Writing Pen, Premium Graduation Gift, Executive Pocket Pen",
      brand: "BASTION",
      priceText: "$44.99",
      priceValue: 44.99,
      rating: 4.6,
      reviewCount: 1996,
      imageUrl: "https://m.media-amazon.com/images/I/81ZjXgxGurL._AC_SL640_.jpg",
      interests: ["EDC"],
    },
    {
      asin: "B001GH0GP0",
      title: "LEATHERMAN Surge 21-in-1 Heavy-Duty Multi-Tool",
      fullTitle: "LEATHERMAN Surge 21-in-1 Heavy-Duty Multi-Tool, Black | Spring-Action Scissors, Replaceable Wire Cutters & Saw for Work, Home, DIY & Auto, 25-Year Guarantee",
      brand: "Leatherman",
      priceText: "$159.95",
      priceValue: 159.95,
      rating: 4.6,
      reviewCount: 1377,
      imageUrl: "https://m.media-amazon.com/images/I/61fELMGSnuL._AC_SL640_.jpg",
      interests: ["EDC"],
    },
    {
      asin: "B0B255WM7B",
      title: "Lary Gray 4.8'' Titanium Alloy Bolt Action Pen with 3…",
      fullTitle: "Lary Gray 4.8'' Titanium Alloy Bolt Action Pen with 3 Extra Refills in Box | Titanium alloy bolt action pen, Ballpoint pen, Light weight, Stainless steel pen clip, Portable, EDC, 3 extra refills in box",
      brand: "Lary",
      priceText: "$24.70",
      priceValue: 24.7,
      rating: 4.4,
      reviewCount: 119,
      imageUrl: "https://m.media-amazon.com/images/I/5140PgVGW2L._AC_SL640_.jpg",
      interests: ["EDC"],
    },
  ],
  Candles: [
    {
      asin: "B0CTJGJL2T",
      title: "GODONLIF Candle Warmer Lamp with Timer",
      fullTitle: "GODONLIF Candle Warmer Lamp with Timer, Birthday Gifts for Women Home Decor | 24h Cycle Timer Dimmable Wax Melt Warmer with 2 Bulbs, Fall Decor for Home Living Room Halloween Decorations Gifts for Mom",
      brand: "GODONLIF",
      priceText: "$12.99",
      priceValue: 12.99,
      rating: 4.7,
      reviewCount: 9825,
      imageUrl: "https://m.media-amazon.com/images/I/810vcJJDrkL._AC_SL640_.jpg",
      interests: ["Candles"],
    },
    {
      asin: "B0CDRDK6MR",
      title: "seenlast Candle Warmer Lamp with Timer Dimmer Adjustable…",
      fullTitle: "seenlast Candle Warmer Lamp with Timer Dimmer Adjustable Height for New Home Bedroom,Mothers Day Gifts,Vintage Home Decor for Scented Jar",
      brand: "seenlast",
      priceText: "$23.96",
      priceValue: 23.96,
      rating: 4.4,
      reviewCount: 4270,
      imageUrl: "https://m.media-amazon.com/images/I/71lTyTayb4L._AC_SL640_.jpg",
      interests: ["Candles"],
    },
    {
      asin: "B0DZFGTCLR",
      title: "Candle Warmer Lamp with Timer Home Decor Birthday Gifts…",
      fullTitle: "Candle Warmer Lamp with Timer Home Decor Birthday Gifts for Women | Dimmable Candle Warmer for Jar Candles, Height Adjustable Wax Melts Warmer,Room Decor House Warming Gifts New",
      brand: "Candle",
      priceText: "$19.99",
      priceValue: 19.99,
      rating: 4.6,
      reviewCount: 4125,
      imageUrl: "https://m.media-amazon.com/images/I/71t96oyL+UL._AC_SL640_.jpg",
      interests: ["Candles"],
    },
  ],
  Blankets: [
    {
      asin: "B092LZLLGF",
      title: "yescool Weighted Blanket for Adults",
      fullTitle: "yescool Weighted Blanket for Adults (20 lbs, 60” x 80”, Grey) Cooling Heavy Blanket for Sleeping Perfect for 190-210 lbs, Queen Size Breathable Blanket with Premium Glass Bead, Machine Washable",
      brand: "yescool",
      priceText: "$35.19",
      priceValue: 35.19,
      rating: 4.5,
      reviewCount: 11578,
      imageUrl: "https://m.media-amazon.com/images/I/61heqwhPQyL._AC_SL640_.jpg",
      interests: ["Blankets"],
    },
    {
      asin: "B07ZJVTW82",
      title: "Bare Home Cotton Weighted Blanket",
      fullTitle: "Bare Home Cotton Weighted Blanket (Light Grey, 48&#34;x72&#34; 15lbs) | Full or Queen Size for Adults, All-Natural 100% Cotton, Premium Heavy Blanket Nontoxic Glass Beads",
      brand: "Bare Home",
      priceText: "$64.99",
      priceValue: 64.99,
      rating: 4.6,
      reviewCount: 7043,
      imageUrl: "https://m.media-amazon.com/images/I/71QnNiDsTjL._AC_SL640_.jpg",
      interests: ["Blankets"],
    },
    {
      asin: "B0CR14YJ23",
      title: "Mr. Sandman Weighted Blanket for Adults",
      fullTitle: "Mr. Sandman Weighted Blanket for Adults, Queen Size 15 lbs, 60 x 80 Inches | Cooling Soft Minky for Hot Sleepers; Machine Washable; Filled with Glass Beads; Heavy Bed Throw for Sleep; Grey",
      brand: "Mr. Sandman",
      priceText: "$34.19",
      priceValue: 34.19,
      rating: 4.6,
      reviewCount: 1692,
      imageUrl: "https://m.media-amazon.com/images/I/81GSOCXzt-L._AC_SL640_.jpg",
      interests: ["Blankets"],
    },
  ],
  Mugs: [
    {
      asin: "B0F7X26WFF",
      title: "vancasso SIMI 16 oz Large Coffee Mugs Set of 6",
      fullTitle: "vancasso SIMI 16 oz Large Coffee Mugs Set of 6, Ceramic Cups with Handle | Bohemian Mug, Ideal for Coffee, Latte, Tea, Cappuccino and Hot Chocolate, Dishwasher Microwave Safe for Daily Use Gift Set",
      brand: "vancasso",
      priceText: "$39.98",
      priceValue: 39.98,
      rating: 4.8,
      reviewCount: 1205,
      imageUrl: "https://m.media-amazon.com/images/I/81QTvBqXJhL._AC_SL640_.jpg",
      interests: ["Mugs"],
    },
    {
      asin: "B0BJ8ZSGGL",
      title: "Morandi Color Ceramic Coffee Mugs Set of 6",
      fullTitle: "Morandi Color Ceramic Coffee Mugs Set of 6 (Large),18 oz Coffee Cups with Handle, Latte Mug, Big Mug for Women, Men, Great for Tea Hot Chocolate, Microwave Safe, Modern, Unique Style for Any Kitchen",
      brand: "Gencywe",
      priceText: "$26.99",
      priceValue: 26.99,
      rating: 4.8,
      reviewCount: 922,
      imageUrl: "https://m.media-amazon.com/images/I/61fH3O+p23L._AC_SL640_.jpg",
      interests: ["Mugs"],
    },
    {
      asin: "B08D1P5J7J",
      title: "DISCOUNT PROMOS Custom Ceramic Campfire Coffee Mugs 13…",
      fullTitle: "DISCOUNT PROMOS Custom Ceramic Campfire Coffee Mugs 13 oz. Set of 10/50/100, Personalized Bulk Pack - Perfect for Tea, Espresso, Cappuccino, Hot Cocoa - White",
      brand: "DISCOUNT PROMOS",
      priceText: "$75.99",
      priceValue: 75.99,
      rating: 4.4,
      reviewCount: 907,
      imageUrl: "https://m.media-amazon.com/images/I/71bo0pVAzaL._AC_SL640_.jpg",
      interests: ["Mugs"],
    },
  ],
  Plants: [
    {
      asin: "B0CF48K7FY",
      title: "YNNICO Indoor Self Watering Planters with Drainage Holes…",
      fullTitle: "YNNICO Indoor Self Watering Planters with Drainage Holes and Saucers, 8, 7, 6.5, 6, 5.5, 5 Inches, Black, 6 Pots",
      brand: "YNNICO",
      priceText: "$23.01",
      priceValue: 23.01,
      rating: 4.6,
      reviewCount: 4717,
      imageUrl: "https://m.media-amazon.com/images/I/719MB0Tuw7L._AC_SL640_.jpg",
      interests: ["Plants"],
    },
    {
      asin: "B0FV7P4XKP",
      title: "Self-Watering Pots for Indoor and Outdoor Plants 4 Pack",
      fullTitle: "Self-Watering Pots for Indoor and Outdoor Plants 4 Pack, 6/8/10/12 Inch Planters with Water Level Indicator & Deep Reservoir, Decorative Flower Pots for Home Decor",
      brand: "Self-Watering",
      priceText: "$24.99",
      priceValue: 24.99,
      rating: 4.6,
      reviewCount: 502,
      imageUrl: "https://m.media-amazon.com/images/I/81dIR5pQAIL._AC_SL640_.jpg",
      interests: ["Plants"],
    },
    {
      asin: "B0GVGBTRRL",
      title: "Self Watering Pots for Indoor Plants",
      fullTitle: "Self Watering Pots for Indoor Plants (5/5.5/6/6.5/8 Inch), Terra Cotta Planters with Water Level Indicator & Drainage,Wicking Pots for Monstera, Herbs & Snake Plant (Black, 5/5.5/6/6.5/8 Inch)",
      brand: "Self",
      priceText: "$25.99",
      priceValue: 25.99,
      rating: 4.6,
      reviewCount: 497,
      imageUrl: "https://m.media-amazon.com/images/I/71bfQhHW9gL._AC_SL640_.jpg",
      interests: ["Plants"],
    },
  ],
  Organization: [
    {
      asin: "B08KXKVT4K",
      title: "Vtopmart 25 PCS Clear Plastic Drawer Organizers Set",
      fullTitle: "Vtopmart 25 PCS Clear Plastic Drawer Organizers Set, 4-Size Versatile Bathroom and Vanity Drawer Organizer Trays, Storage Bins for Makeup, Bedroom, Kitchen Gadgets Utensils and Office | 4-Size Versatile Makeup Organizer, Storage Containers Small Bins for Makeup, Jewelries, Bedroom, Kitchen Utensils and Office",
      brand: "Vtopmart",
      priceText: "$18.99",
      priceValue: 18.99,
      rating: 4.7,
      reviewCount: 49184,
      imageUrl: "https://m.media-amazon.com/images/I/81yj+PUYVxL._AC_SL640_.jpg",
      interests: ["Organization"],
    },
    {
      asin: "B0B1M6ML2J",
      title: "25 PCS Clear Plastic Drawer Organizer",
      fullTitle: "25 PCS Clear Plastic Drawer Organizer, Makeup Organizers and Storage Bins | 4 Sizes Desk Drawer Divider Organizers and Storage Bins for Makeup, Jewelry, Gadgets for Kitchen, Bedroom, Bathroom, Office",
      brand: "WOWBOX",
      priceText: "$16.99",
      priceValue: 16.99,
      rating: 4.4,
      reviewCount: 14609,
      imageUrl: "https://m.media-amazon.com/images/I/81RChUS0zjL._AC_SL640_.jpg",
      interests: ["Organization"],
    },
    {
      asin: "B0CTYTDYFV",
      title: "Grow Forward Bamboo Drawer Organizer Boxes",
      fullTitle: "Grow Forward Bamboo Drawer Organizer Boxes - Set of 14 Wooden Drawer Organizers for Kitchen, Bathroom, Office, Desk, Vanity, Makeup - Non-Slip Junk Drawer Organizer Trays for Storage and Organization",
      brand: "Grow Forward",
      priceText: "$33.99",
      priceValue: 33.99,
      rating: 4.6,
      reviewCount: 548,
      imageUrl: "https://m.media-amazon.com/images/I/91bDnk38uoL._AC_SL640_.jpg",
      interests: ["Organization"],
    },
  ],
  "Kitchen Gadgets": [
    {
      asin: "B082314NFL",
      title: "Zulay Kitchen Milk Frother Handheld Electric Whisk",
      fullTitle: "Zulay Kitchen Milk Frother Handheld Electric Whisk – Frother Wand, Durable Drink Mixer, Coffee Frother, Hand Blender, Frother for Protein Powder, Matcha & More - Black",
      brand: "Zulay Kitchen",
      priceText: "$8.49",
      priceValue: 8.49,
      rating: 4.4,
      reviewCount: 238223,
      imageUrl: "https://m.media-amazon.com/images/I/71pi8AcRHLL._AC_SL640_.jpg",
      interests: ["Kitchen Gadgets"],
    },
    {
      asin: "B0C9LP36Q5",
      title: "SYOKAMI 2026 Upgrade Kitchen Knife Set",
      fullTitle: "SYOKAMI 2026 Upgrade Kitchen Knife Set, Foldable Magnetic Acacia Wood Block | Japanese Style 7-Piece High Carbon Stainless Steel Chef Knife Set, Full Tang Wood Handle, Damascus Pattern, Ideal for Gift",
      brand: "SYOKAMI",
      priceText: "$89.98",
      priceValue: 89.98,
      rating: 4.6,
      reviewCount: 663,
      imageUrl: "https://m.media-amazon.com/images/I/81dz0YPJsNL._AC_SL640_.jpg",
      interests: ["Kitchen Gadgets"],
    },
    {
      asin: "B0FQ4XY21Z",
      title: "Milk Frother 4-in-1 Electric Milk Steamer",
      fullTitle: "Milk Frother 4-in-1 Electric Milk Steamer, Hot Cold Foam Milk Maker, White | milk frother steamer with hot & cold foam modes 350ml capacity fast frothing for latte cappuccino macchiato & chocolate",
      brand: "Wowteam",
      priceText: "$33.23",
      priceValue: 33.23,
      rating: 4.4,
      reviewCount: 262,
      imageUrl: "https://m.media-amazon.com/images/I/61MGX1C7DkL._AC_SL640_.jpg",
      interests: ["Kitchen Gadgets"],
    },
  ],
  Camping: [
    {
      asin: "B0915B6X66",
      title: "Collapsible Portable LED Camping Lantern XTAUTO…",
      fullTitle: "Collapsible Portable LED Camping Lantern XTAUTO Lightweight Waterproof Solar USB Rechargeable LED Flashlight Survival Kits for Indoor Outdoor Home Emergency Light Power Outages Hiking Hurricane 4-Pack",
      brand: "XTAUTO",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.5,
      reviewCount: 12405,
      imageUrl: "https://m.media-amazon.com/images/I/71fAPuDi5lL._AC_SL640_.jpg",
      interests: ["Camping"],
    },
    {
      asin: "B01N5MBY3J",
      title: "ENERGIZER LED Camping Lantern 360 PRO",
      fullTitle: "ENERGIZER LED Camping Lantern 360 PRO, IPX4 Water Resistant Tent Light, Ultra Bright Battery Powered Lanterns for Camping, Outdoors, Emergency Power Outage",
      brand: "Energizer",
      priceText: "$19.25",
      priceValue: 19.25,
      rating: 4.5,
      reviewCount: 7767,
      imageUrl: "https://m.media-amazon.com/images/I/61MQXMS8IjL._AC_SL640_.jpg",
      interests: ["Camping"],
    },
    {
      asin: "B0FL22QSGP",
      title: "Glocusent LED Ultra Bright Camping Lantern",
      fullTitle: "Glocusent LED Ultra Bright Camping Lantern, Camping Light with Max 1500LM | 5000mAh Portable Camping Light with 3 Colors & 5 Brightness, SOS, Rechargeable Lantern for Power Outages Hiking Emergency",
      brand: "Glocusent",
      priceText: "$22.99",
      priceValue: 22.99,
      rating: 4.7,
      reviewCount: 1209,
      imageUrl: "https://m.media-amazon.com/images/I/61UmCXLNw0L._AC_SL640_.jpg",
      interests: ["Camping"],
    },
  ],
  Hiking: [
    {
      asin: "B09DR857JF",
      title: "Teton Oasis/Trailrunner Hydration Backpack",
      fullTitle: "Teton Oasis/Trailrunner Hydration Backpack – Lightweight Water Pack with 2L/3L Bladder for Hiking, Running, Cycling, Biking 18L/22L Sizes – Sewn-in Rain Cover – Fits Men and Women",
      brand: "TETON Sports",
      priceText: "$43.21",
      priceValue: 43.21,
      rating: 4.5,
      reviewCount: 4473,
      imageUrl: "https://m.media-amazon.com/images/I/71PRru6m28L._AC_SL640_.jpg",
      interests: ["Hiking"],
    },
    {
      asin: "B09P1HZRXH",
      title: "Maelstrom 40L Hiking Backpack",
      fullTitle: "Maelstrom 40L Hiking Backpack, Lightweight Camping Daypack with Rain Cover | Water-Resistant Rip-Stop Nylon, Wet/Dry Separation, Multi-Pockets, Survival Whistle. Ideal For Men, Women, Travel, Trekking",
      brand: "Maelstrom",
      priceText: "$32.69",
      priceValue: 32.69,
      rating: 4.5,
      reviewCount: 3439,
      imageUrl: "https://m.media-amazon.com/images/I/81siwI2UxEL._AC_SL640_.jpg",
      interests: ["Hiking"],
    },
    {
      asin: "B0DSR9H8N6",
      title: "Osprey Daylite Cinch Backpack",
      fullTitle: "Osprey Daylite Cinch Backpack - Lightweight Travel Bag for Hikes, Festivals, and Everyday, Seaweed Green Amazon Exclusive",
      brand: "Osprey",
      priceText: "$56.34",
      priceValue: 56.34,
      rating: 4.5,
      reviewCount: 1141,
      imageUrl: "https://m.media-amazon.com/images/I/61D5+H7zoqL._AC_SL640_.jpg",
      interests: ["Hiking"],
    },
  ],
  Fishing: [
    {
      asin: "B0FL1XXLQZ",
      title: "Ghosthorn Fishing Tackle Backpack with Tackle Boxes Rod…",
      fullTitle: "Ghosthorn Fishing Tackle Backpack with Tackle Boxes Rod Holder Fishing Bag | Waterproof Fishing Tackle Bag with Lip Gripper, Pliers, Lures and Tackle Accessories Fishing Kit Gifts for Anglers Sling",
      brand: "Ghosthorn",
      priceText: "$41.99",
      priceValue: 41.99,
      rating: 4.6,
      reviewCount: 5643,
      imageUrl: "https://m.media-amazon.com/images/I/812W5PqQL-L._AC_SL640_.jpg",
      interests: ["Fishing"],
    },
    {
      asin: "B012FGME00",
      title: "Booms Fishing X1 Aluminum Fishing Pliers Saltwater",
      fullTitle: "Booms Fishing X1 Aluminum Fishing Pliers Saltwater, Surf Fishing Tackle Kit, Fishing Multitool Hook Remover Braided Fishing Line Cutting and Split Ring with Coiled Lanyard and Sheath",
      brand: "Booms Fishing",
      priceText: "$19.99",
      priceValue: 19.99,
      rating: 4.6,
      reviewCount: 2843,
      imageUrl: "https://m.media-amazon.com/images/I/61nm2VOiJUS._AC_SL640_.jpg",
      interests: ["Fishing"],
    },
    {
      asin: "B0DQ7YG3K8",
      title: "PLUSINNO Fishing Tackle Kit",
      fullTitle: "PLUSINNO Fishing Tackle Kit, Large 12X Spacious 4-Layer Tackle Box, 547 Pcs | All-In-One Fishing Gear, 16 Pro Rigs, Large Capacity, Ultra-Durable Pliers, Gripper, Remover, Freshwater Bass Gift for Men",
      brand: "PLUSINNO",
      priceText: "$49.37",
      priceValue: 49.37,
      rating: 4.5,
      reviewCount: 861,
      imageUrl: "https://m.media-amazon.com/images/I/81XzUaF006L._AC_SL640_.jpg",
      interests: ["Fishing"],
    },
  ],
  Gardening: [
    {
      asin: "B09F9C3KFS",
      title: "Grenebo Heavy Duty Gardening Tools with Handbag",
      fullTitle: "Grenebo Heavy Duty Gardening Tools with Handbag, Gardening Gifts for Women | Rust-Resistant Steel Garden Tool Sets for Women, Men, Durable, Ergonomic Wooden Handle, Idea for Planting Work",
      brand: "Grenebo",
      priceText: "$26.58",
      priceValue: 26.58,
      rating: 4.8,
      reviewCount: 4138,
      imageUrl: "https://m.media-amazon.com/images/I/81hk0PGpklL._AC_SL640_.jpg",
      interests: ["Gardening"],
    },
    {
      asin: "B0BVN1MDYN",
      title: "Aimerla Gardening Tools Set of 9 Heavy Duty Garden Tools…",
      fullTitle: "Aimerla Gardening Tools Set of 9 Heavy Duty Garden Tools with Non-Slip Rubber Grip with Large Garden Bag, Durable for Garden, Weeding, Gifts for Women,Men",
      brand: "Aimerla",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.7,
      reviewCount: 365,
      imageUrl: "https://m.media-amazon.com/images/I/71veQdDIPlL._AC_SL640_.jpg",
      interests: ["Gardening"],
    },
    {
      asin: "B0F1F76D4R",
      title: "Brown Garden Tools Set 12-Piece",
      fullTitle: "Brown Garden Tools Set 12-Piece, Gardening Gifts for Women Men | Aluminum Garden Hand Tool Kit with Non-Slip Ergonomic Handle, Storage Tote Bag, Apron, Gloves and Kneeling Pad for Gardeners",
      brand: "iHansee",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.6,
      reviewCount: 291,
      imageUrl: "https://m.media-amazon.com/images/I/71B5lDw6a4L._AC_SL640_.jpg",
      interests: ["Gardening"],
    },
  ],
  "Travel Gear": [
    {
      asin: "B08S35399Y",
      title: "BAGAIL 8 Set Packing Cubes Luggage Packing Organizers for…",
      fullTitle: "BAGAIL 8 Set Packing Cubes Luggage Packing Organizers for Travel Accessories-Cream",
      brand: "BAGAIL",
      priceText: "$16.98",
      priceValue: 16.98,
      rating: 4.6,
      reviewCount: 43778,
      imageUrl: "https://m.media-amazon.com/images/I/61aFuRVWe3L._AC_SL640_.jpg",
      interests: ["Travel Gear"],
    },
    {
      asin: "B0B7BFMHNF",
      title: "Veken 10 Set/8 Set Packing Cubes for Travel Essentials",
      fullTitle: "Veken 10 Set/8 Set Packing Cubes for Travel Essentials,Anti-Wrinkle Buckled Suitcase Organizer for Shoe & Toiletry Bag,Carry On Luggage Bag for Airplane & College Dorm Room Accessories,Women Men Gifts",
      brand: "Veken",
      priceText: "$16.99",
      priceValue: 16.99,
      rating: 4.6,
      reviewCount: 34057,
      imageUrl: "https://m.media-amazon.com/images/I/71jrpiYKJ-L._AC_SL640_.jpg",
      interests: ["Travel Gear"],
    },
    {
      asin: "B074KQ4C85",
      title: "LeanTravel Premium Compression Packing Cubes for Travel",
      fullTitle: "LeanTravel Premium Compression Packing Cubes for Travel - Suitcase Organizer Bags with Double Zipper & Breathable Mesh Panel - Space Saving Carry On Luggage Essentials (6-Pack, Grey)",
      brand: "LeanTravel",
      priceText: "$49.99",
      priceValue: 49.99,
      rating: 4.6,
      reviewCount: 6856,
      imageUrl: "https://m.media-amazon.com/images/I/91yzyCXksdL._AC_SL640_.jpg",
      interests: ["Travel Gear"],
    },
  ],
  Outdoors: [
    {
      asin: "B0033990ZQ",
      title: "Coleman Portable Camping Chair with 4-Can Cooler",
      fullTitle: "Coleman Portable Camping Chair with 4-Can Cooler, Cushioned Seat & Back with Side Pockets & Cup Holder, Carry Bag Included, Great for Camping, Tailgating, Firepits, Patio, & More",
      brand: "Coleman",
      priceText: "$49.99",
      priceValue: 49.99,
      rating: 4.7,
      reviewCount: 61162,
      imageUrl: "https://m.media-amazon.com/images/I/71oAndTPdRL._AC_SL640_.jpg",
      interests: ["Outdoors"],
    },
    {
      asin: "B0BY8FXR47",
      title: "MOON LENCE Portable Camping Chair Backpacking Chair",
      fullTitle: "MOON LENCE Portable Camping Chair Backpacking Chair - The 4th Generation Ultralight Folding Chair - Compact, Lightweight Foldable Chairs for Hiking Mountaineering, Beach (Black-1Pack)",
      brand: "MOON LENCE",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.3,
      reviewCount: 1610,
      imageUrl: "https://m.media-amazon.com/images/I/71WDfPgBn-L._AC_SL640_.jpg",
      interests: ["Outdoors"],
    },
    {
      asin: "B0CQJR8NLW",
      title: "ONETIGRIS Tigerblade Camping Chair",
      fullTitle: "ONETIGRIS Tigerblade Camping Chair, Lightweight Folding Backpacking Hiking Chair, Compact Portable 330 lbs Capacity",
      brand: "ONETIGRIS",
      priceText: "$39.98",
      priceValue: 39.98,
      rating: 4.6,
      reviewCount: 1534,
      imageUrl: "https://m.media-amazon.com/images/I/61+ZNLh3XmL._AC_SL640_.jpg",
      interests: ["Outdoors"],
    },
  ],
  Fiction: [
    {
      asin: "1250178630",
      title: "The Women: A Novel",
      fullTitle: "The Women: A Novel",
      brand: "Kristin Hannah",
      priceText: "$20.58",
      priceValue: 20.58,
      rating: 4.7,
      reviewCount: 347900,
      imageUrl: "https://m.media-amazon.com/images/I/913C+MR3S5L._SL1500_.jpg",
      interests: ["Fiction"],
    },
    {
      asin: "1954118813",
      title: "The Calamity Club: A Novel",
      fullTitle: "The Calamity Club: A Novel",
      brand: "Kathryn Stockett",
      priceText: "$24.01",
      priceValue: 24.01,
      rating: 4.7,
      reviewCount: 46420,
      imageUrl: "https://m.media-amazon.com/images/I/81pFuCA04TL._SL1500_.jpg",
      interests: ["Fiction"],
    },
    {
      asin: "1464246238",
      title: "Nantucket Second Chances: A Novel",
      fullTitle: "Nantucket Second Chances: A Novel",
      brand: "Pamela Kelley",
      priceText: "$19.50",
      priceValue: 19.5,
      rating: 4.6,
      reviewCount: 1913,
      imageUrl: "https://m.media-amazon.com/images/I/91wpWa9ICFL._SL1500_.jpg",
      interests: ["Fiction"],
    },
  ],
  Nonfiction: [
    {
      asin: "0593296966",
      title: "1929: Inside the Greatest Crash in Wall Street…",
      fullTitle: "1929: Inside the Greatest Crash in Wall Street History--and How It Shattered a Nation",
      brand: "Andrew Ross Sorkin",
      priceText: "$17.47",
      priceValue: 17.47,
      rating: 4.6,
      reviewCount: 11122,
      imageUrl: "https://m.media-amazon.com/images/I/71ojtb1VxuL._SL1500_.jpg",
      interests: ["Nonfiction"],
    },
    {
      asin: "1501183052",
      title: "A Walk in the Park: The True Story of a Spectacular…",
      fullTitle: "A Walk in the Park: The True Story of a Spectacular Misadventure in the Grand Canyon",
      brand: "Kevin Fedarko",
      priceText: "$15.97",
      priceValue: 15.97,
      rating: 4.6,
      reviewCount: 3681,
      imageUrl: "https://m.media-amazon.com/images/I/71Hh8ke57vL._SL1500_.jpg",
      interests: ["Nonfiction"],
    },
    {
      asin: "1668067242",
      title: "Regime Change: Inside the Imperial Presidency of Donald…",
      fullTitle: "Regime Change: Inside the Imperial Presidency of Donald Trump",
      brand: "Maggie Haberman",
      priceText: "$23.78",
      priceValue: 23.78,
      rating: 4.7,
      reviewCount: 3259,
      imageUrl: "https://m.media-amazon.com/images/I/81M5IyHImzL._SL1500_.jpg",
      interests: ["Nonfiction"],
    },
  ],
  Puzzles: [
    {
      asin: "B07QN82G93",
      title: "Ceaco - Disney/Pixar Clips - 2000 Piece Jigsaw Puzzle",
      fullTitle: "Ceaco - Disney/Pixar Clips - 2000 Piece Jigsaw Puzzle , 5&#34; | Officially Licensed, Made in USA, Recycled Board, Finished Size 38.5 x 26.5 in, Includes Poster, Giftable, Frameable",
      brand: "Ceaco",
      priceText: "$18.99",
      priceValue: 18.99,
      rating: 4.6,
      reviewCount: 2886,
      imageUrl: "https://m.media-amazon.com/images/I/91nWwp2ciqL._AC_SL640_.jpg",
      interests: ["Puzzles"],
    },
    {
      asin: "B0D13Z9HGV",
      title: "PICKFORU Stained Glass Puzzle Tree of Life Puzzles for…",
      fullTitle: "PICKFORU Stained Glass Puzzle Tree of Life Puzzles for Adults 1000 Pieces, Impossible Hard Difficult Challenging Puzzles for Adults, Colorful Mosaic Tree of Life Jigsaw Puzzle 1000 Pieces",
      brand: "PICKFORU",
      priceText: "$15.10",
      priceValue: 15.1,
      rating: 4.7,
      reviewCount: 2820,
      imageUrl: "https://m.media-amazon.com/images/I/81hWonALyqL._AC_SL640_.jpg",
      interests: ["Puzzles"],
    },
    {
      asin: "B0FB45JNNK",
      title: "Puzzles for Adults 1000 Pieces",
      fullTitle: "Puzzles for Adults 1000 Pieces, 2 Pack Unique 1000 Piece Lake and Night View Jigsaw Puzzles, Premium Scenic Landscape Puzzles & Nature Theme for Challenging Game Night",
      brand: "Puzzles",
      priceText: "$9.99",
      priceValue: 9.99,
      rating: 4.5,
      reviewCount: 454,
      imageUrl: "https://m.media-amazon.com/images/I/81VFcYFsCFL._AC_SL640_.jpg",
      interests: ["Puzzles"],
    },
  ],
  Journaling: [
    {
      asin: "B0BTV6X42F",
      title: "RILIHO Leather Journal Notebook",
      fullTitle: "RILIHO Leather Journal Notebook - Genuine Leather Journals for Writing 260 Pages 5x7.1 Inches Vintage Journal For Man and Women Gifts For Man Artist,Travel Journal,Brown",
      brand: "RILIHO",
      priceText: "$16.98",
      priceValue: 16.98,
      rating: 4.7,
      reviewCount: 11429,
      imageUrl: "https://m.media-amazon.com/images/I/71-t+mZNV+L._AC_SL640_.jpg",
      interests: ["Journaling"],
    },
    {
      asin: "B093DC7M1F",
      title: "cuero Vintage Leather Journal",
      fullTitle: "cuero Vintage Leather Journal - Antique Handmade Leather Bound journal with deckle edge paper for Men And Women Diary - Leather Sketchbook - Drawing Journal Notebook - Great Gift (5 by 7 inch)",
      brand: "cuero",
      priceText: "$22.99",
      priceValue: 22.99,
      rating: 4.7,
      reviewCount: 2248,
      imageUrl: "https://m.media-amazon.com/images/I/81mu+GJpkUL._AC_SL640_.jpg",
      interests: ["Journaling"],
    },
    {
      asin: "B09NF5JBMF",
      title: "Classic Leather Notebook Writing Journal",
      fullTitle: "Classic Leather Notebook Writing Journal, Softcover, Black | Narrow Ruled, Table of Contents and Numbered Pages",
      brand: "Leatherpress",
      priceText: "$34.99",
      priceValue: 34.99,
      rating: 4.5,
      reviewCount: 199,
      imageUrl: "https://m.media-amazon.com/images/I/81+dAjoGrYL._AC_SL640_.jpg",
      interests: ["Journaling"],
    },
  ],
  Audiobooks: [
    {
      asin: "B0GGBQPG9C",
      title: "SHOKZ OpenRun Pro 2 Bone Conduction Headphone",
      fullTitle: "SHOKZ OpenRun Pro 2 Bone Conduction Headphone, Rose Gold, Free Gym Bag | Claim free Gym Bag；Amazon Exclusive Color; DualPitch premium sound；Smart Mic; IP55; 12H battery; Running/Cycling/Hiking",
      brand: "SHOKZ",
      priceText: "$199.95",
      priceValue: 199.95,
      rating: 4.4,
      reviewCount: 7886,
      imageUrl: "https://m.media-amazon.com/images/I/51PKqQdtbsL._AC_SL640_.jpg",
      interests: ["Audiobooks"],
    },
    {
      asin: "B0GK9FWDX5",
      title: "PSIER Bone Conduction Headphones",
      fullTitle: "PSIER Bone Conduction Headphones, 2026 Upgrade Open Ear Running Headphones | Bluetooth 6.0, 10Hrs Playtime, 23g Lightweight Comfort, IPX5 Waterproof, Bone Conduction Earbuds with Mic for Gym, Workouts",
      brand: "PSIER",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.1,
      reviewCount: 3385,
      imageUrl: "https://m.media-amazon.com/images/I/51mt3Vd6EdL._AC_SL640_.jpg",
      interests: ["Audiobooks"],
    },
    {
      asin: "B0DTRW94T7",
      title: "Raycon Bone Conduction Headphones Bluetooth",
      fullTitle: "Raycon Bone Conduction Headphones Bluetooth - Open Ear Running Headphones, Sweat & Water-Resistant Earbuds with Mic for Sports & Workouts, 13hr Playtime (Gray)",
      brand: "Raycon",
      priceText: "$99.99",
      priceValue: 99.99,
      rating: 4,
      reviewCount: 1482,
      imageUrl: "https://m.media-amazon.com/images/I/81f44pkcA3L._AC_SL640_.jpg",
      interests: ["Audiobooks"],
    },
  ],
  "Language Learning": [
    {
      asin: "B0BHMVDH9S",
      title: "Startcan Spanish & English Talking Flash Cards for…",
      fullTitle: "Startcan Spanish & English Talking Flash Cards for Toddlers 1 2 3 4 5 6, Audible Toys for Kids to Learn Spanish - 258 Cards and 516 Words(Blue)",
      brand: "Startcan",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.5,
      reviewCount: 1024,
      imageUrl: "https://m.media-amazon.com/images/I/61sGbTDyqRL._AC_SL640_.jpg",
      interests: ["Language Learning"],
    },
    {
      asin: "B0F2J881BL",
      title: "Learn French Fast for Adult Beginners: 8-in-1 Workbook…",
      fullTitle: "Learn French Fast for Adult Beginners: 8-in-1 Workbook: From Beginner to Advanced: 15-Minute Daily Lessons and Exercises, Short Stories, Plus a Rich Vocabulary Collection (Easy French)",
      brand: "Speak Abroad Academy",
      priceText: "$30.00",
      priceValue: 30,
      rating: 4.6,
      reviewCount: 747,
      imageUrl: "https://m.media-amazon.com/images/I/61IcXMviOgL._SL1499_.jpg",
      interests: ["Language Learning"],
    },
    {
      asin: "B0CZLZRT8S",
      title: "Spanish Flash Cards for Adult Beginners & Kids",
      fullTitle: "Spanish Flash Cards for Adult Beginners & Kids – Learn 100+ Verbs, Words & Phrases for Everyday Conversation – Gift for Adults, Travelers & Students",
      brand: "Spanish",
      priceText: "$16.97",
      priceValue: 16.97,
      rating: 4.5,
      reviewCount: 158,
      imageUrl: "https://m.media-amazon.com/images/I/81PsmmjbiLL._AC_SL640_.jpg",
      interests: ["Language Learning"],
    },
  ],
  Drawing: [
    {
      asin: "B081ZY3Y7G",
      title: "KALOUR 76 Drawing Sketching Kit Set",
      fullTitle: "KALOUR 76 Drawing Sketching Kit Set - Pro Art Supplies with Sketchbook & Watercolor Paper - Include Tutorial,Pastel,Watercolor,Sketch,Colored,Metallic,Charcoal Pencils - for Artists Beginners Adults",
      brand: "KALOUR",
      priceText: "$25.99",
      priceValue: 25.99,
      rating: 4.8,
      reviewCount: 5642,
      imageUrl: "https://m.media-amazon.com/images/I/81lpxybWt0L._AC_SL640_.jpg",
      interests: ["Drawing"],
    },
    {
      asin: "B0B7N2Q1NQ",
      title: "Caliart 176PCS Art Supplies Sketching Kit",
      fullTitle: "Caliart 176PCS Art Supplies Sketching Kit, 100 Sheets 3-Color Sketch Book | Graphite Colored Charcoal Watercolor & Metallic Pencils, Drawing Supplies Set Gifts for Adults Teens Girls Boys Kids",
      brand: "Caliart",
      priceText: "$23.39",
      priceValue: 23.39,
      rating: 4.8,
      reviewCount: 3992,
      imageUrl: "https://m.media-amazon.com/images/I/81fdzjwyfcL._AC_SL640_.jpg",
      interests: ["Drawing"],
    },
    {
      asin: "B092M2FXB8",
      title: "Prina 50 Pack Drawing Set Sketch Kit",
      fullTitle: "Prina 50 Pack Drawing Set Sketch Kit, Sketching Supplies with 3-Color Sketchbook, Graphite, and Charcoal Pencils, Pro Art Drawing Kit for Artists Adults Teens Beginner Kid, Ideal for Shading, Blending",
      brand: "PRINA",
      priceText: "$15.99",
      priceValue: 15.99,
      rating: 4.8,
      reviewCount: 3935,
      imageUrl: "https://m.media-amazon.com/images/I/81c5HUpuVMS._AC_SL640_.jpg",
      interests: ["Drawing"],
    },
  ],
  Knitting: [
    {
      asin: "B0CY2NR8YF",
      title: "Yarniss Crochet Kit for Beginners",
      fullTitle: "Yarniss Crochet Kit for Beginners,All in One Crochet Kits for Adult,Navy | Ergonomic Crochet Hooks Set with 840 Yards Crochet Yarn & Crochet Accessories,Learn to Crochet with Instruction & Tutorial",
      brand: "Yarniss",
      priceText: "$18.85",
      priceValue: 18.85,
      rating: 4.6,
      reviewCount: 1228,
      imageUrl: "https://m.media-amazon.com/images/I/71q-07Qr5eL._AC_SL640_.jpg",
      interests: ["Knitting"],
    },
    {
      asin: "B0D6B6N4KT",
      title: "Aeelike Crochet Kits for Beginners Adults Kids",
      fullTitle: "Aeelike Crochet Kits for Beginners Adults Kids, Complete Crochet Set, Navy | Crochet Kit for Beginners Young and Old, All-inclusive Kit with Crochet Hooks 655 Yards Yarn Instruction Knit Bag, Ideal Gift",
      brand: "Aeelike",
      priceText: "$19.99",
      priceValue: 19.99,
      rating: 4.6,
      reviewCount: 1143,
      imageUrl: "https://m.media-amazon.com/images/I/912vDSZGL5L._AC_SL640_.jpg",
      interests: ["Knitting"],
    },
    {
      asin: "B0F2GVXBGH",
      title: "Complete Knitting Kit for Beginners",
      fullTitle: "Complete Knitting Kit for Beginners - Learn to Knit Kit with Knitting Accessories Like Thick Beginner Yarn in Gray, Bamboo Needles for Beginners & More - Includes Video Tutorials & Written Guide",
      brand: "Granny Squirrel",
      priceText: "$28.99",
      priceValue: 28.99,
      rating: 4.4,
      reviewCount: 218,
      imageUrl: "https://m.media-amazon.com/images/I/812WqPAbH5L._AC_SL640_.jpg",
      interests: ["Knitting"],
    },
  ],
  DIY: [
    {
      asin: "B00ET5VMTU",
      title: "DEWALT 20V Max Cordless Drill Driver Set",
      fullTitle: "DEWALT 20V Max Cordless Drill Driver Set, 2 Speed, High Performance Motor, Includes 2 XR 1.3Ah Li-Ion Batteries, Charger and Contractor Bag (DCD771C2)",
      brand: "DEWALT",
      priceText: "$119.00",
      priceValue: 119,
      rating: 4.8,
      reviewCount: 49709,
      imageUrl: "https://m.media-amazon.com/images/I/81dmm7FomNL._AC_SL640_.jpg",
      interests: ["DIY"],
    },
    {
      asin: "B0079IRIG0",
      title: "BLACK+DECKER 20V MAX* POWERCONNECT Cordless Drill Driver…",
      fullTitle: "BLACK+DECKER 20V MAX* POWERCONNECT Cordless Drill Driver Kit with Drill Bit Set and Sockets, 100 pc. Tool Kit for Home, Battery and Charger Included, Orange (BDC120VA100)",
      brand: "BLACK+DECKER",
      priceText: "$64.99",
      priceValue: 64.99,
      rating: 4.6,
      reviewCount: 5601,
      imageUrl: "https://m.media-amazon.com/images/I/71d8QMcVgYL._AC_SL640_.jpg",
      interests: ["DIY"],
    },
    {
      asin: "B0DFXLWYQ9",
      title: "PULITUO'S 20V Cordless Drill/Driver",
      fullTitle: "PULITUO'S 20V Cordless Drill/Driver, Electric Screwdriver - 2 Batteries, 30Nm, 21+1 Torque, 2 Speed, Keyless 3/8&#34; Chase Drill with LED Light, Kit for Home (Green)",
      brand: "PULITUO",
      priceText: "$35.98",
      priceValue: 35.98,
      rating: 4.5,
      reviewCount: 1671,
      imageUrl: "https://m.media-amazon.com/images/I/71z5BWWiTKL._AC_SL640_.jpg",
      interests: ["DIY"],
    },
  ],
  Stationery: [
    {
      asin: "B08BZQ3M1R",
      title: "Scriveiner Silver Chrome Fountain Pen",
      fullTitle: "Scriveiner Silver Chrome Fountain Pen - Stunning Luxury Pen, Real Gold Finish Schmidt Gilded Nib (Medium), Best Pen Gift Set for Men & Women, Professional, Executive Office, Nice Pens",
      brand: "Scriveiner",
      priceText: "$49.99",
      priceValue: 49.99,
      rating: 4.6,
      reviewCount: 13511,
      imageUrl: "https://m.media-amazon.com/images/I/71ysls1SlEL._AC_SL640_.jpg",
      interests: ["Stationery"],
    },
    {
      asin: "B07771NCMZ",
      title: "3 Pcs Wooden Pens Set with Gift Case/Best Writing…",
      fullTitle: "3 Pcs Wooden Pens Set with Gift Case/Best Writing Fountain Fancy Ballpoint Pen and Luxury Gel Pen with Ink Refills, Promotional Business Designer Pens | Wood Fountain Pen, Unique Ballpoint Pen and Writing Gel Pen with Ink Refills, Business Designer Pens for Lawyer Writers Gifts",
      brand: "Ren Handcraft",
      priceText: "$12.99",
      priceValue: 12.99,
      rating: 4.4,
      reviewCount: 2772,
      imageUrl: "https://m.media-amazon.com/images/I/61jq+3E3iYL._AC_SL640_.jpg",
      interests: ["Stationery"],
    },
    {
      asin: "B07GSGN32P",
      title: "Wordsworth & Black Bamboo Wood Fountain Pen Set for…",
      fullTitle: "Wordsworth & Black Bamboo Wood Fountain Pen Set for Writing, Medium Nib | Rosewood, Gift for Men Women, German Iridium 18K Gilded, Calligraphy Journaling, Converter + 6 Cartridges, Refillable",
      brand: "Wordsworth & Black",
      priceText: "$36.15",
      priceValue: 36.15,
      rating: 4.4,
      reviewCount: 1398,
      imageUrl: "https://m.media-amazon.com/images/I/51bqn1--ZbL._AC_SL640_.jpg",
      interests: ["Stationery"],
    },
  ],
  Painting: [
    {
      asin: "B07Z93LQDB",
      title: "Shuttle Art Acrylic Paint",
      fullTitle: "Shuttle Art Acrylic Paint, 36 Colors Acrylic Paint Set with Brushes & Palette, 2oz/60ml Bottles, Rich Pigments Non-toxic for Artists Kids & Adults, Painting on Canvas Rocks Ceramic Wood",
      brand: "Shuttle Art",
      priceText: "$9.00",
      priceValue: 9,
      rating: 4.7,
      reviewCount: 11030,
      imageUrl: "https://m.media-amazon.com/images/I/71hFt5Z-ytL._AC_SL640_.jpg",
      interests: ["Painting"],
    },
    {
      asin: "B08QNJ7KSF",
      title: "Acrylic Paint Set Canvas Art Paints 24 Colors Perfect…",
      fullTitle: "Acrylic Paint Set Canvas Art Paints 24 Colors Perfect Paint Finish (0.41oz,12 ml) With 3 Brushes - Painting Canvas, Paper, Wood, Rock, MDF, Ceramic & Fabric",
      brand: "KOLOR KINGDOM",
      priceText: "$8.54",
      priceValue: 8.54,
      rating: 4.7,
      reviewCount: 9421,
      imageUrl: "https://m.media-amazon.com/images/I/81EMhOO6Y4L._AC_SL640_.jpg",
      interests: ["Painting"],
    },
    {
      asin: "B0D97QTK9W",
      title: "Nicpro 80PCS Acrylic Paint Canvas Set for Adults with 36…",
      fullTitle: "Nicpro 80PCS Acrylic Paint Canvas Set for Adults with 36 Paints (36ML) | Art Painting Supplies Kit, Table Wood Easel, 10 Canvas Panels, 12 Paint Brushes, Paper Pad, Cup, Palette, For Beginner Artist",
      brand: "Nicpro",
      priceText: "$27.99",
      priceValue: 27.99,
      rating: 4.7,
      reviewCount: 353,
      imageUrl: "https://m.media-amazon.com/images/I/81wtql1giDL._AC_SL640_.jpg",
      interests: ["Painting"],
    },
  ],
  Jewelry: [
    {
      asin: "B0BRCFFSNK",
      title: "AKOZLIN 6-Tier Jewelry Box Organizer Functional 5 Drawers…",
      fullTitle: "AKOZLIN 6-Tier Jewelry Box Organizer Functional 5 Drawers Leather Jewelry Storage Case for Women Girls Ring Necklace Earring Bracelet Holder Organizer with Mirror Black Regular",
      brand: "AKOZLIN",
      priceText: "$49.99",
      priceValue: 49.99,
      rating: 4.7,
      reviewCount: 3529,
      imageUrl: "https://m.media-amazon.com/images/I/81hHlKxD4HL._AC_SL640_.jpg",
      interests: ["Jewelry"],
    },
    {
      asin: "B0BZD4QBYZ",
      title: "SONGMICS Jewelry Organizer",
      fullTitle: "SONGMICS Jewelry Organizer, LED Jewelry Cabinet Wall/Door Mounted, Lockable Rounded Wide Mirror with Storage, Interior Mirror, 3.9 x 16.5 x 42.5 Inches, White Surface with Greige Lining",
      brand: "SONGMICS",
      priceText: "$85.23",
      priceValue: 85.23,
      rating: 4.5,
      reviewCount: 1796,
      imageUrl: "https://m.media-amazon.com/images/I/71gNNSpljdL._AC_SL640_.jpg",
      interests: ["Jewelry"],
    },
    {
      asin: "B0F1T5WYPQ",
      title: "bussdis 2 Tier Bracelet Holder Display",
      fullTitle: "bussdis 2 Tier Bracelet Holder Display, Necklace Holder Organizer, Beige | Velvet Necklace Holder | Jewelry Tree | Jewelry Towers | Jewelry Stand Organizer for Necklaces, Bracelets, Earrings, Rings",
      brand: "bussdis",
      priceText: "$18.59",
      priceValue: 18.59,
      rating: 4.7,
      reviewCount: 602,
      imageUrl: "https://m.media-amazon.com/images/I/71Moqc-KYNL._AC_SL640_.jpg",
      interests: ["Jewelry"],
    },
  ],
  Fragrance: [
    {
      asin: "B09231NL5H",
      title: "Bella Vita Organic Man Luxury Perfume Gift Set 4x20 ML…",
      fullTitle: "Bella Vita Organic Man Luxury Perfume Gift Set 4x20 ML for Men with Dominus, Oud, CEO, Impact Perfume|Woody, Citrusy Long Lasting EDP & EDC Fragrance Scent |80 ML | Long-lasting men's perfume gift set with CEO Man, G.O.A.T., KLUB & OUD Eau de Parfum for every occasion.",
      brand: "Bella Vita Luxury",
      priceText: "$22.94",
      priceValue: 22.94,
      rating: 4.2,
      reviewCount: 41406,
      imageUrl: "https://m.media-amazon.com/images/I/61V7ch8HzGL._SL1348_.jpg",
      interests: ["Fragrance"],
    },
    {
      asin: "B000C1VWIQ",
      title: "Estée Lauder Youth-Dew Eau de Parfum Spray with Notes of…",
      fullTitle: "Estée Lauder Youth-Dew Eau de Parfum Spray with Notes of Rose, Spices & Patchouli | Perfumes for Women",
      brand: "Estée Lauder",
      priceText: "$50.00",
      priceValue: 50,
      rating: 4.6,
      reviewCount: 14274,
      imageUrl: "https://m.media-amazon.com/images/I/41LFq44chnL._SL1000_.jpg",
      interests: ["Fragrance"],
    },
    {
      asin: "B008KZBAII",
      title: "Charrier Parfums 10 Eaux de Parfum Luxurious Gift Box",
      fullTitle: "Charrier Parfums 10 Eaux de Parfum Luxurious Gift Box - Made in Provence, France - 57.8 ml",
      brand: "Charrier Parfums",
      priceText: "$29.61",
      priceValue: 29.61,
      rating: 4.4,
      reviewCount: 10315,
      imageUrl: "https://m.media-amazon.com/images/I/71Fv+ht6pBL._SL1254_.jpg",
      interests: ["Fragrance"],
    },
  ],
  Accessories: [
    {
      asin: "B07G43XJ63",
      title: "FURTALK Women's Cashmere Feel Shawl Wrap Soft Blanket…",
      fullTitle: "FURTALK Women's Cashmere Feel Shawl Wrap Soft Blanket Scarf for Weddings | Buttery Soft Viscose Blend, Warm But Not Bulky, Premium High-End Look, Perfect For Evening Dresses & Flights",
      brand: "FURTALK",
      priceText: "$13.49",
      priceValue: 13.49,
      rating: 4.7,
      reviewCount: 7599,
      imageUrl: "https://m.media-amazon.com/images/I/61EQ0xBEAZL._AC_SL640_.jpg",
      interests: ["Accessories"],
    },
    {
      asin: "B07GH5PQMP",
      title: "Fishers Finery Women's 100% Pure Cashmere Winter Scarf",
      fullTitle: "Fishers Finery Women's 100% Pure Cashmere Winter Scarf",
      brand: "Fishers",
      priceText: "$52.99",
      priceValue: 52.99,
      rating: 4.7,
      reviewCount: 521,
      imageUrl: "https://m.media-amazon.com/images/I/813aBzmBYyL._AC_SL640_.jpg",
      interests: ["Accessories"],
    },
    {
      asin: "B0F6JNX8SB",
      title: "Soft Cashmere Blend Wrap Chic Scarf Stole for Women…",
      fullTitle: "Soft Cashmere Blend Wrap Chic Scarf Stole for Women Wayfarer Travel Extra Large 87\"x28\"",
      brand: "Soft",
      priceText: "$32.99",
      priceValue: 32.99,
      rating: 4.5,
      reviewCount: 399,
      imageUrl: "https://m.media-amazon.com/images/I/71IzENAm+jL._AC_SL640_.jpg",
      interests: ["Accessories"],
    },
  ],
  Skincare: [
    {
      asin: "B00375L8SI",
      title: "Elizabeth Arden Eight Hour Cream Skin Protectant",
      fullTitle: "Elizabeth Arden Eight Hour Cream Skin Protectant, All Purpose Beauty Salve, Moisturizing Balm for Body, Repairs Dry Hands, Cracked Feet, Chapped Lips & Cuticles",
      brand: "Elizabeth Arden",
      priceText: "$30.40",
      priceValue: 30.4,
      rating: 4.3,
      reviewCount: 12771,
      imageUrl: "https://m.media-amazon.com/images/I/61NjfRMcL9L._SL1500_.jpg",
      interests: ["Skincare"],
    },
    {
      asin: "B0DWXCNQN4",
      title: "Anua PDRN Hyaluronic Acid Capsule 100 Serum Mask",
      fullTitle: "Anua PDRN Hyaluronic Acid Capsule 100 Serum Mask, 10ea | Hydrating & Soothing Face Mask for Glass Skin, Dewy Glow and Firm Looking Skin, Salmon DNA & Collagen, Lightweight Texture",
      brand: "ANUA",
      priceText: "$20.40",
      priceValue: 20.4,
      rating: 4.6,
      reviewCount: 452,
      imageUrl: "https://m.media-amazon.com/images/I/61UhhfSAvWL._SL1500_.jpg",
      interests: ["Skincare"],
    },
    {
      asin: "B0DT468CJC",
      title: "Pyunkang Yul PKY Calming Skincare Gift Set with Premium…",
      fullTitle: "Pyunkang Yul PKY Calming Skincare Gift Set with Premium Gift Wrapping, Vegan, Korean Skincare (3-item set)",
      brand: "Pyunkang Yul",
      priceText: "$43.69",
      priceValue: 43.69,
      rating: 4.7,
      reviewCount: 206,
      imageUrl: "https://m.media-amazon.com/images/I/61W6s7X59wL._SL1000_.jpg",
      interests: ["Skincare"],
    },
  ],
  Loungewear: [
    {
      asin: "B00XKDBEOA",
      title: "Richie House Women's Plush Soft Warm Fleece Bathrobe Robe…",
      fullTitle: "Richie House Women's Plush Soft Warm Fleece Bathrobe Robe RH1591",
      brand: "Richie",
      priceText: "$39.99",
      priceValue: 39.99,
      rating: 4.7,
      reviewCount: 3155,
      imageUrl: "https://m.media-amazon.com/images/I/81EO7NN60kL._AC_SL640_.jpg",
      interests: ["Loungewear"],
    },
    {
      asin: "B0913JCXN3",
      title: "SlumberMee Mens Fleece Plush Robe with Hood Ultra Soft…",
      fullTitle: "SlumberMee Mens Fleece Plush Robe with Hood Ultra Soft Fluffy Full Length Long with Pockets Luxurious House Coat",
      brand: "SlumberMee",
      priceText: "$28.33",
      priceValue: 28.33,
      rating: 4.7,
      reviewCount: 1142,
      imageUrl: "https://m.media-amazon.com/images/I/81yIz7tqp5L._AC_SL640_.jpg",
      interests: ["Loungewear"],
    },
    {
      asin: "B0FN3MY1F9",
      title: "Berkshire Extra-Fluffy™ Women‘s Robe",
      fullTitle: "Berkshire Extra-Fluffy™ Women‘s Robe — Luxurious Fluffy Plush Bathrobe,Soft Warm Fleece Loungewear with Pockets and Belt",
      brand: "Berkshire",
      priceText: "$29.99",
      priceValue: 29.99,
      rating: 4.7,
      reviewCount: 115,
      imageUrl: "https://m.media-amazon.com/images/I/715NeZ3ir5L._AC_SL640_.jpg",
      interests: ["Loungewear"],
    },
  ],
  Dogs: [
    {
      asin: "B08RY2YRFG",
      title: "DR CATCH Dog Puzzle",
      fullTitle: "DR CATCH Dog Puzzle,Dogs Food Toys for IQ Training & Mental Enrichment,Dog Treat Puzzle(Blue)",
      brand: "DR CATCH",
      priceText: "$8.99",
      priceValue: 8.99,
      rating: 4.3,
      reviewCount: 16718,
      imageUrl: "https://m.media-amazon.com/images/I/71e4HQ06H4L._AC_SL640_.jpg",
      interests: ["Dogs"],
    },
    {
      asin: "B09XXPCB4T",
      title: "PETSTA Dog Puzzle Toys",
      fullTitle: "PETSTA Dog Puzzle Toys, Treat Dispensing Dog Enrichment Toys for IQ Training and Brain Stimulation, Interactive Mentally Stimulating Toys as Gifts for Puppies, Cats, Dogs",
      brand: "PETSTA",
      priceText: "$12.81",
      priceValue: 12.81,
      rating: 4.4,
      reviewCount: 9152,
      imageUrl: "https://m.media-amazon.com/images/I/71THE2QseXL._AC_SL640_.jpg",
      interests: ["Dogs"],
    },
    {
      asin: "B08FY3396J",
      title: "Dog Puzzle Toys for Smart Dogs",
      fullTitle: "Dog Puzzle Toys for Smart Dogs, Interactive, Treat Puzzle, Enrichment",
      brand: "HOUNDGAMES",
      priceText: "$29.74",
      priceValue: 29.74,
      rating: 4.2,
      reviewCount: 1964,
      imageUrl: "https://m.media-amazon.com/images/I/91CEJaeNlRL._AC_SL640_.jpg",
      interests: ["Dogs"],
    },
  ],
  Cats: [
    {
      asin: "B0BJZMBBQM",
      title: "Potaroma Cat Toys Flapping Bird",
      fullTitle: "Potaroma Cat Toys Flapping Bird (No Flying), Lifelike Sandpiper Chirp Tweet, Rechargeable Touch Activated Kitten Toy Interactive Cat Exercise Toys for All Breeds Cat Kicker Catnip Toys 4.0\" | Lifelike Sandpiper Chirp, Touch Activated, Rechargeable Kitten Kitty Exercise Catnip Kicker for All Breeds 4.0 Inches",
      brand: "Potaroma",
      priceText: "$16.99",
      priceValue: 16.99,
      rating: 4.4,
      reviewCount: 21374,
      imageUrl: "https://m.media-amazon.com/images/I/712R7NJ-nDL._AC_SL640_.jpg",
      interests: ["Cats"],
    },
    {
      asin: "B0FSD5WXP3",
      title: "Interactive Cat Toys for Indoor Cats",
      fullTitle: "Interactive Cat Toys for Indoor Cats,Automatic Kitten Tunnel Toy | Rechargeable Touch Activated, Hide and Seek Design, Colorful Fluffy Tail & Butterfly, Cat Enrichment Toy for Bored Cats",
      brand: "Interactive",
      priceText: "$26.30",
      priceValue: 26.3,
      rating: 4.4,
      reviewCount: 2522,
      imageUrl: "https://m.media-amazon.com/images/I/81BkPMBXkKL._AC_SL640_.jpg",
      interests: ["Cats"],
    },
    {
      asin: "B0F5M61JH8",
      title: "Globlazer Giant Tall Heavy Duty Cat Tower for Indoor…",
      fullTitle: "Globlazer Giant Tall Heavy Duty Cat Tower for Indoor Large Cats, F83B | XXL Multi-Level Large Cat Condo with 8 Scratching Posts, Hammock, 2 Cat Caves, 2 Platform, Dark Grey",
      brand: "Globlazer",
      priceText: "$119.99",
      priceValue: 119.99,
      rating: 4.5,
      reviewCount: 263,
      imageUrl: "https://m.media-amazon.com/images/I/81UIMVFIPVL._AC_SL640_.jpg",
      interests: ["Cats"],
    },
  ],
  "Small Pets": [
    {
      asin: "B09MK9GJFS",
      title: "Grddaef 20 PCS Bunny Chew Toys for Teeth",
      fullTitle: "Grddaef 20 PCS Bunny Chew Toys for Teeth, Natural Rabbit Toys Apple Wood Grass Timothy Sticks Chew and Treat for Guinea Pigs Hamster Chinchillas",
      brand: "Grddaef",
      priceText: "$9.99",
      priceValue: 9.99,
      rating: 4.6,
      reviewCount: 4635,
      imageUrl: "https://m.media-amazon.com/images/I/81UtwO9FU-L._AC_SL640_.jpg",
      interests: ["Small Pets"],
    },
    {
      asin: "B0DQ95LSNS",
      title: "Jorewood 21 Pcs Rabbit Chew Toys for Teeth",
      fullTitle: "Jorewood 21 Pcs Rabbit Chew Toys for Teeth, Natural Bunny Toys Peach Wood Grass Timothy Sticks Chew and Treat for Guinea Pigs Hamster Chinchillas and Other Small Pets",
      brand: "Jorewood",
      priceText: "$8.88",
      priceValue: 8.88,
      rating: 4.5,
      reviewCount: 404,
      imageUrl: "https://m.media-amazon.com/images/I/81Mr3e9gfXL._AC_SL640_.jpg",
      interests: ["Small Pets"],
    },
    {
      asin: "B0BYDFJZRW",
      title: "700g Apple Sticks Molar Wood Treats",
      fullTitle: "700g Apple Sticks Molar Wood Treats, Rabbit Toys Chinchilla Guinea Pig Bunny Toys Wood Chews Sticks for Teeth Rabbit Food Guinea Pig Hamster Gerbil Chews Small Animals Snacks(200 Pcs)",
      brand: "Petawi",
      priceText: "$13.48",
      priceValue: 13.48,
      rating: 4.4,
      reviewCount: 218,
      imageUrl: "https://m.media-amazon.com/images/I/71vtPyx-9mL._AC_SL640_.jpg",
      interests: ["Small Pets"],
    },
  ],
  "Pet Parent Gear": [
    {
      asin: "B00BAGTNAQ",
      title: "ChomChom Roller Pet Hair Remover",
      fullTitle: "ChomChom Roller Pet Hair Remover – Original Size Reusable Lint Roller for Cat & Dog Hair on Furniture, Couch, Carpet, Car, Rugs & Bedding – Portable, Eco-Friendly (White)",
      brand: "ChomChom Roller",
      priceText: "$23.99",
      priceValue: 23.99,
      rating: 4.5,
      reviewCount: 205134,
      imageUrl: "https://m.media-amazon.com/images/I/71mmJsbMGZL._AC_SL640_.jpg",
      interests: ["Pet Parent Gear"],
    },
    {
      asin: "B09YN468KG",
      title: "BLACK+DECKER Pet Hair Remover",
      fullTitle: "BLACK+DECKER Pet Hair Remover, Roller, Remove Dog Hair and Cat Hair Easily (HMSCT0001)",
      brand: "BLACK+DECKER",
      priceText: "$12.71",
      priceValue: 12.71,
      rating: 4.6,
      reviewCount: 3850,
      imageUrl: "https://m.media-amazon.com/images/I/61GHMSH8OaL._AC_SL640_.jpg",
      interests: ["Pet Parent Gear"],
    },
    {
      asin: "B07CZGVXKZ",
      title: "Evercare Pet Hair Lint Rollers All Purpose Use 100…",
      fullTitle: "Evercare Pet Hair Lint Rollers All Purpose Use 100 Easy-Tear Sheets Per Roll Reusable Sticky Roller Pets Cat & Dog Hair Remover Contoured Handle For Furniture Clothing & Cars, Set of 3, Green",
      brand: "Evercare",
      priceText: "$12.08",
      priceValue: 12.08,
      rating: 4.6,
      reviewCount: 2918,
      imageUrl: "https://m.media-amazon.com/images/I/71-76QHsvfL._AC_SL640_.jpg",
      interests: ["Pet Parent Gear"],
    },
  ],
};

/** Flat, de-duplicated product list in catalog order. */
export const ALL_CATALOG_PRODUCTS = Object.values(AMAZON_GIFT_CATALOG).flat();

/** ASIN -> product, for resolving saved recommendations back to catalog data. */
export const CATALOG_BY_ASIN = new Map(
  ALL_CATALOG_PRODUCTS.map((product) => [product.asin, product]),
);

/**
 * Broad-appeal fallback deck (best reviewed pick per interest group) used when a
 * giftee has no catalog interests selected — e.g. custom-only interests.
 */
export const CROWD_PLEASERS = [
  "B004D9XYWU",
  "B083L8RNJR",
  "B0C3HCD34R",
  "B082314NFL",
  "B0033990ZQ",
  "1250178630",
  "B00ET5VMTU",
  "B09231NL5H",
  "B00BAGTNAQ",
].map((asin) => CATALOG_BY_ASIN.get(asin)).filter(Boolean);
